webpackJsonp([89,175],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1023);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	/*!
	 * vue-resource v0.9.3
	 * https://github.com/vuejs/vue-resource
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	 */
	
	var RESOLVED = 0;
	var REJECTED = 1;
	var PENDING = 2;
	
	function Promise$2(executor) {
	
	    this.state = PENDING;
	    this.value = undefined;
	    this.deferred = [];
	
	    var promise = this;
	
	    try {
	        executor(function (x) {
	            promise.resolve(x);
	        }, function (r) {
	            promise.reject(r);
	        });
	    } catch (e) {
	        promise.reject(e);
	    }
	}
	
	Promise$2.reject = function (r) {
	    return new Promise$2(function (resolve, reject) {
	        reject(r);
	    });
	};
	
	Promise$2.resolve = function (x) {
	    return new Promise$2(function (resolve, reject) {
	        resolve(x);
	    });
	};
	
	Promise$2.all = function all(iterable) {
	    return new Promise$2(function (resolve, reject) {
	        var count = 0,
	            result = [];
	
	        if (iterable.length === 0) {
	            resolve(result);
	        }
	
	        function resolver(i) {
	            return function (x) {
	                result[i] = x;
	                count += 1;
	
	                if (count === iterable.length) {
	                    resolve(result);
	                }
	            };
	        }
	
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$2.resolve(iterable[i]).then(resolver(i), reject);
	        }
	    });
	};
	
	Promise$2.race = function race(iterable) {
	    return new Promise$2(function (resolve, reject) {
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$2.resolve(iterable[i]).then(resolve, reject);
	        }
	    });
	};
	
	var p$1 = Promise$2.prototype;
	
	p$1.resolve = function resolve(x) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (x === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        var called = false;
	
	        try {
	            var then = x && x['then'];
	
	            if (x !== null && typeof x === 'object' && typeof then === 'function') {
	                then.call(x, function (x) {
	                    if (!called) {
	                        promise.resolve(x);
	                    }
	                    called = true;
	                }, function (r) {
	                    if (!called) {
	                        promise.reject(r);
	                    }
	                    called = true;
	                });
	                return;
	            }
	        } catch (e) {
	            if (!called) {
	                promise.reject(e);
	            }
	            return;
	        }
	
	        promise.state = RESOLVED;
	        promise.value = x;
	        promise.notify();
	    }
	};
	
	p$1.reject = function reject(reason) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (reason === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        promise.state = REJECTED;
	        promise.value = reason;
	        promise.notify();
	    }
	};
	
	p$1.notify = function notify() {
	    var promise = this;
	
	    nextTick(function () {
	        if (promise.state !== PENDING) {
	            while (promise.deferred.length) {
	                var deferred = promise.deferred.shift(),
	                    onResolved = deferred[0],
	                    onRejected = deferred[1],
	                    resolve = deferred[2],
	                    reject = deferred[3];
	
	                try {
	                    if (promise.state === RESOLVED) {
	                        if (typeof onResolved === 'function') {
	                            resolve(onResolved.call(undefined, promise.value));
	                        } else {
	                            resolve(promise.value);
	                        }
	                    } else if (promise.state === REJECTED) {
	                        if (typeof onRejected === 'function') {
	                            resolve(onRejected.call(undefined, promise.value));
	                        } else {
	                            reject(promise.value);
	                        }
	                    }
	                } catch (e) {
	                    reject(e);
	                }
	            }
	        }
	    });
	};
	
	p$1.then = function then(onResolved, onRejected) {
	    var promise = this;
	
	    return new Promise$2(function (resolve, reject) {
	        promise.deferred.push([onResolved, onRejected, resolve, reject]);
	        promise.notify();
	    });
	};
	
	p$1.catch = function (onRejected) {
	    return this.then(undefined, onRejected);
	};
	
	var PromiseObj = window.Promise || Promise$2;
	
	function Promise$1(executor, context) {
	
	    if (executor instanceof PromiseObj) {
	        this.promise = executor;
	    } else {
	        this.promise = new PromiseObj(executor.bind(context));
	    }
	
	    this.context = context;
	}
	
	Promise$1.all = function (iterable, context) {
	    return new Promise$1(PromiseObj.all(iterable), context);
	};
	
	Promise$1.resolve = function (value, context) {
	    return new Promise$1(PromiseObj.resolve(value), context);
	};
	
	Promise$1.reject = function (reason, context) {
	    return new Promise$1(PromiseObj.reject(reason), context);
	};
	
	Promise$1.race = function (iterable, context) {
	    return new Promise$1(PromiseObj.race(iterable), context);
	};
	
	var p = Promise$1.prototype;
	
	p.bind = function (context) {
	    this.context = context;
	    return this;
	};
	
	p.then = function (fulfilled, rejected) {
	
	    if (fulfilled && fulfilled.bind && this.context) {
	        fulfilled = fulfilled.bind(this.context);
	    }
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new Promise$1(this.promise.then(fulfilled, rejected), this.context);
	};
	
	p.catch = function (rejected) {
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new Promise$1(this.promise.catch(rejected), this.context);
	};
	
	p.finally = function (callback) {
	
	    return this.then(function (value) {
	        callback.call(this);
	        return value;
	    }, function (reason) {
	        callback.call(this);
	        return PromiseObj.reject(reason);
	    });
	};
	
	var debug = false;
	var util = {};
	var array = [];
	function Util (Vue) {
	    util = Vue.util;
	    debug = Vue.config.debug || !Vue.config.silent;
	}
	
	function warn(msg) {
	    if (typeof console !== 'undefined' && debug) {
	        console.warn('[VueResource warn]: ' + msg);
	    }
	}
	
	function error(msg) {
	    if (typeof console !== 'undefined') {
	        console.error(msg);
	    }
	}
	
	function nextTick(cb, ctx) {
	    return util.nextTick(cb, ctx);
	}
	
	function trim(str) {
	    return str.replace(/^\s*|\s*$/g, '');
	}
	
	var isArray = Array.isArray;
	
	function isString(val) {
	    return typeof val === 'string';
	}
	
	function isBoolean(val) {
	    return val === true || val === false;
	}
	
	function isFunction(val) {
	    return typeof val === 'function';
	}
	
	function isObject(obj) {
	    return obj !== null && typeof obj === 'object';
	}
	
	function isPlainObject(obj) {
	    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	}
	
	function isFormData(obj) {
	    return typeof FormData !== 'undefined' && obj instanceof FormData;
	}
	
	function when(value, fulfilled, rejected) {
	
	    var promise = Promise$1.resolve(value);
	
	    if (arguments.length < 2) {
	        return promise;
	    }
	
	    return promise.then(fulfilled, rejected);
	}
	
	function options(fn, obj, opts) {
	
	    opts = opts || {};
	
	    if (isFunction(opts)) {
	        opts = opts.call(obj);
	    }
	
	    return merge(fn.bind({ $vm: obj, $options: opts }), fn, { $options: opts });
	}
	
	function each(obj, iterator) {
	
	    var i, key;
	
	    if (typeof obj.length == 'number') {
	        for (i = 0; i < obj.length; i++) {
	            iterator.call(obj[i], obj[i], i);
	        }
	    } else if (isObject(obj)) {
	        for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	                iterator.call(obj[key], obj[key], key);
	            }
	        }
	    }
	
	    return obj;
	}
	
	var assign = Object.assign || _assign;
	
	function merge(target) {
	
	    var args = array.slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source, true);
	    });
	
	    return target;
	}
	
	function defaults(target) {
	
	    var args = array.slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	
	        for (var key in source) {
	            if (target[key] === undefined) {
	                target[key] = source[key];
	            }
	        }
	    });
	
	    return target;
	}
	
	function _assign(target) {
	
	    var args = array.slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source);
	    });
	
	    return target;
	}
	
	function _merge(target, source, deep) {
	    for (var key in source) {
	        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
	                target[key] = {};
	            }
	            if (isArray(source[key]) && !isArray(target[key])) {
	                target[key] = [];
	            }
	            _merge(target[key], source[key], deep);
	        } else if (source[key] !== undefined) {
	            target[key] = source[key];
	        }
	    }
	}
	
	function root (options, next) {
	
	    var url = next(options);
	
	    if (isString(options.root) && !url.match(/^(https?:)?\//)) {
	        url = options.root + '/' + url;
	    }
	
	    return url;
	}
	
	function query (options, next) {
	
	    var urlParams = Object.keys(Url.options.params),
	        query = {},
	        url = next(options);
	
	    each(options.params, function (value, key) {
	        if (urlParams.indexOf(key) === -1) {
	            query[key] = value;
	        }
	    });
	
	    query = Url.params(query);
	
	    if (query) {
	        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
	    }
	
	    return url;
	}
	
	/**
	 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
	 */
	
	function expand(url, params, variables) {
	
	    var tmpl = parse(url),
	        expanded = tmpl.expand(params);
	
	    if (variables) {
	        variables.push.apply(variables, tmpl.vars);
	    }
	
	    return expanded;
	}
	
	function parse(template) {
	
	    var operators = ['+', '#', '.', '/', ';', '?', '&'],
	        variables = [];
	
	    return {
	        vars: variables,
	        expand: function (context) {
	            return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function (_, expression, literal) {
	                if (expression) {
	
	                    var operator = null,
	                        values = [];
	
	                    if (operators.indexOf(expression.charAt(0)) !== -1) {
	                        operator = expression.charAt(0);
	                        expression = expression.substr(1);
	                    }
	
	                    expression.split(/,/g).forEach(function (variable) {
	                        var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
	                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	                        variables.push(tmp[1]);
	                    });
	
	                    if (operator && operator !== '+') {
	
	                        var separator = ',';
	
	                        if (operator === '?') {
	                            separator = '&';
	                        } else if (operator !== '#') {
	                            separator = operator;
	                        }
	
	                        return (values.length !== 0 ? operator : '') + values.join(separator);
	                    } else {
	                        return values.join(',');
	                    }
	                } else {
	                    return encodeReserved(literal);
	                }
	            });
	        }
	    };
	}
	
	function getValues(context, operator, key, modifier) {
	
	    var value = context[key],
	        result = [];
	
	    if (isDefined(value) && value !== '') {
	        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	            value = value.toString();
	
	            if (modifier && modifier !== '*') {
	                value = value.substring(0, parseInt(modifier, 10));
	            }
	
	            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	        } else {
	            if (modifier === '*') {
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            result.push(encodeValue(operator, value[k], k));
	                        }
	                    });
	                }
	            } else {
	                var tmp = [];
	
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        tmp.push(encodeValue(operator, value));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            tmp.push(encodeURIComponent(k));
	                            tmp.push(encodeValue(operator, value[k].toString()));
	                        }
	                    });
	                }
	
	                if (isKeyOperator(operator)) {
	                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
	                } else if (tmp.length !== 0) {
	                    result.push(tmp.join(','));
	                }
	            }
	        }
	    } else {
	        if (operator === ';') {
	            result.push(encodeURIComponent(key));
	        } else if (value === '' && (operator === '&' || operator === '?')) {
	            result.push(encodeURIComponent(key) + '=');
	        } else if (value === '') {
	            result.push('');
	        }
	    }
	
	    return result;
	}
	
	function isDefined(value) {
	    return value !== undefined && value !== null;
	}
	
	function isKeyOperator(operator) {
	    return operator === ';' || operator === '&' || operator === '?';
	}
	
	function encodeValue(operator, value, key) {
	
	    value = operator === '+' || operator === '#' ? encodeReserved(value) : encodeURIComponent(value);
	
	    if (key) {
	        return encodeURIComponent(key) + '=' + value;
	    } else {
	        return value;
	    }
	}
	
	function encodeReserved(str) {
	    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	        if (!/%[0-9A-Fa-f]/.test(part)) {
	            part = encodeURI(part);
	        }
	        return part;
	    }).join('');
	}
	
	function template (options) {
	
	    var variables = [],
	        url = expand(options.url, options.params, variables);
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	}
	
	/**
	 * Service for URL templating.
	 */
	
	var ie = document.documentMode;
	var el = document.createElement('a');
	
	function Url(url, params) {
	
	    var self = this || {},
	        options = url,
	        transform;
	
	    if (isString(url)) {
	        options = { url: url, params: params };
	    }
	
	    options = merge({}, Url.options, self.$options, options);
	
	    Url.transforms.forEach(function (handler) {
	        transform = factory(handler, transform, self.$vm);
	    });
	
	    return transform(options);
	}
	
	/**
	 * Url options.
	 */
	
	Url.options = {
	    url: '',
	    root: null,
	    params: {}
	};
	
	/**
	 * Url transforms.
	 */
	
	Url.transforms = [template, query, root];
	
	/**
	 * Encodes a Url parameter string.
	 *
	 * @param {Object} obj
	 */
	
	Url.params = function (obj) {
	
	    var params = [],
	        escape = encodeURIComponent;
	
	    params.add = function (key, value) {
	
	        if (isFunction(value)) {
	            value = value();
	        }
	
	        if (value === null) {
	            value = '';
	        }
	
	        this.push(escape(key) + '=' + escape(value));
	    };
	
	    serialize(params, obj);
	
	    return params.join('&').replace(/%20/g, '+');
	};
	
	/**
	 * Parse a URL and return its components.
	 *
	 * @param {String} url
	 */
	
	Url.parse = function (url) {
	
	    if (ie) {
	        el.href = url;
	        url = el.href;
	    }
	
	    el.href = url;
	
	    return {
	        href: el.href,
	        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
	        port: el.port,
	        host: el.host,
	        hostname: el.hostname,
	        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
	        search: el.search ? el.search.replace(/^\?/, '') : '',
	        hash: el.hash ? el.hash.replace(/^#/, '') : ''
	    };
	};
	
	function factory(handler, next, vm) {
	    return function (options) {
	        return handler.call(vm, options, next);
	    };
	}
	
	function serialize(params, obj, scope) {
	
	    var array = isArray(obj),
	        plain = isPlainObject(obj),
	        hash;
	
	    each(obj, function (value, key) {
	
	        hash = isObject(value) || isArray(value);
	
	        if (scope) {
	            key = scope + '[' + (plain || hash ? key : '') + ']';
	        }
	
	        if (!scope && array) {
	            params.add(value.name, value.value);
	        } else if (hash) {
	            serialize(params, value, key);
	        } else {
	            params.add(key, value);
	        }
	    });
	}
	
	function xdrClient (request) {
	    return new Promise$1(function (resolve) {
	
	        var xdr = new XDomainRequest(),
	            handler = function (event) {
	
	            var response = request.respondWith(xdr.responseText, {
	                status: xdr.status,
	                statusText: xdr.statusText
	            });
	
	            resolve(response);
	        };
	
	        request.abort = function () {
	            return xdr.abort();
	        };
	
	        xdr.open(request.method, request.getUrl(), true);
	        xdr.timeout = 0;
	        xdr.onload = handler;
	        xdr.onerror = handler;
	        xdr.ontimeout = function () {};
	        xdr.onprogress = function () {};
	        xdr.send(request.getBody());
	    });
	}
	
	var ORIGIN_URL = Url.parse(location.href);
	var SUPPORTS_CORS = 'withCredentials' in new XMLHttpRequest();
	
	function cors (request, next) {
	
	    if (!isBoolean(request.crossOrigin) && crossOrigin(request)) {
	        request.crossOrigin = true;
	    }
	
	    if (request.crossOrigin) {
	
	        if (!SUPPORTS_CORS) {
	            request.client = xdrClient;
	        }
	
	        delete request.emulateHTTP;
	    }
	
	    next();
	}
	
	function crossOrigin(request) {
	
	    var requestUrl = Url.parse(Url(request));
	
	    return requestUrl.protocol !== ORIGIN_URL.protocol || requestUrl.host !== ORIGIN_URL.host;
	}
	
	function body (request, next) {
	
	    if (request.emulateJSON && isPlainObject(request.body)) {
	        request.body = Url.params(request.body);
	        request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	    }
	
	    if (isFormData(request.body)) {
	        delete request.headers['Content-Type'];
	    }
	
	    if (isPlainObject(request.body)) {
	        request.body = JSON.stringify(request.body);
	    }
	
	    next(function (response) {
	
	        var contentType = response.headers['Content-Type'];
	
	        if (isString(contentType) && contentType.indexOf('application/json') === 0) {
	
	            try {
	                response.data = response.json();
	            } catch (e) {
	                response.data = null;
	            }
	        } else {
	            response.data = response.text();
	        }
	    });
	}
	
	function jsonpClient (request) {
	    return new Promise$1(function (resolve) {
	
	        var name = request.jsonp || 'callback',
	            callback = '_jsonp' + Math.random().toString(36).substr(2),
	            body = null,
	            handler,
	            script;
	
	        handler = function (event) {
	
	            var status = 0;
	
	            if (event.type === 'load' && body !== null) {
	                status = 200;
	            } else if (event.type === 'error') {
	                status = 404;
	            }
	
	            resolve(request.respondWith(body, { status: status }));
	
	            delete window[callback];
	            document.body.removeChild(script);
	        };
	
	        request.params[name] = callback;
	
	        window[callback] = function (result) {
	            body = JSON.stringify(result);
	        };
	
	        script = document.createElement('script');
	        script.src = request.getUrl();
	        script.type = 'text/javascript';
	        script.async = true;
	        script.onload = handler;
	        script.onerror = handler;
	
	        document.body.appendChild(script);
	    });
	}
	
	function jsonp (request, next) {
	
	    if (request.method == 'JSONP') {
	        request.client = jsonpClient;
	    }
	
	    next(function (response) {
	
	        if (request.method == 'JSONP') {
	            response.data = response.json();
	        }
	    });
	}
	
	function before (request, next) {
	
	    if (isFunction(request.before)) {
	        request.before.call(this, request);
	    }
	
	    next();
	}
	
	/**
	 * HTTP method override Interceptor.
	 */
	
	function method (request, next) {
	
	    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
	        request.headers['X-HTTP-Method-Override'] = request.method;
	        request.method = 'POST';
	    }
	
	    next();
	}
	
	function header (request, next) {
	
	    request.method = request.method.toUpperCase();
	    request.headers = assign({}, Http.headers.common, !request.crossOrigin ? Http.headers.custom : {}, Http.headers[request.method.toLowerCase()], request.headers);
	
	    next();
	}
	
	/**
	 * Timeout Interceptor.
	 */
	
	function timeout (request, next) {
	
	    var timeout;
	
	    if (request.timeout) {
	        timeout = setTimeout(function () {
	            request.abort();
	        }, request.timeout);
	    }
	
	    next(function (response) {
	
	        clearTimeout(timeout);
	    });
	}
	
	function xhrClient (request) {
	    return new Promise$1(function (resolve) {
	
	        var xhr = new XMLHttpRequest(),
	            handler = function (event) {
	
	            var response = request.respondWith('response' in xhr ? xhr.response : xhr.responseText, {
	                status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
	                statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText),
	                headers: parseHeaders(xhr.getAllResponseHeaders())
	            });
	
	            resolve(response);
	        };
	
	        request.abort = function () {
	            return xhr.abort();
	        };
	
	        xhr.open(request.method, request.getUrl(), true);
	        xhr.timeout = 0;
	        xhr.onload = handler;
	        xhr.onerror = handler;
	
	        if (request.progress) {
	            if (request.method === 'GET') {
	                xhr.addEventListener('progress', request.progress);
	            } else if (/^(POST|PUT)$/i.test(request.method)) {
	                xhr.upload.addEventListener('progress', request.progress);
	            }
	        }
	
	        if (request.credentials === true) {
	            xhr.withCredentials = true;
	        }
	
	        each(request.headers || {}, function (value, header) {
	            xhr.setRequestHeader(header, value);
	        });
	
	        xhr.send(request.getBody());
	    });
	}
	
	function parseHeaders(str) {
	
	    var headers = {},
	        value,
	        name,
	        i;
	
	    each(trim(str).split('\n'), function (row) {
	
	        i = row.indexOf(':');
	        name = trim(row.slice(0, i));
	        value = trim(row.slice(i + 1));
	
	        if (headers[name]) {
	
	            if (isArray(headers[name])) {
	                headers[name].push(value);
	            } else {
	                headers[name] = [headers[name], value];
	            }
	        } else {
	
	            headers[name] = value;
	        }
	    });
	
	    return headers;
	}
	
	function Client (context) {
	
	    var reqHandlers = [sendRequest],
	        resHandlers = [],
	        handler;
	
	    if (!isObject(context)) {
	        context = null;
	    }
	
	    function Client(request) {
	        return new Promise$1(function (resolve) {
	
	            function exec() {
	
	                handler = reqHandlers.pop();
	
	                if (isFunction(handler)) {
	                    handler.call(context, request, next);
	                } else {
	                    warn('Invalid interceptor of type ' + typeof handler + ', must be a function');
	                    next();
	                }
	            }
	
	            function next(response) {
	
	                if (isFunction(response)) {
	
	                    resHandlers.unshift(response);
	                } else if (isObject(response)) {
	
	                    resHandlers.forEach(function (handler) {
	                        response = when(response, function (response) {
	                            return handler.call(context, response) || response;
	                        });
	                    });
	
	                    when(response, resolve);
	
	                    return;
	                }
	
	                exec();
	            }
	
	            exec();
	        }, context);
	    }
	
	    Client.use = function (handler) {
	        reqHandlers.push(handler);
	    };
	
	    return Client;
	}
	
	function sendRequest(request, resolve) {
	
	    var client = request.client || xhrClient;
	
	    resolve(client(request));
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	/**
	 * HTTP Response.
	 */
	
	var Response = function () {
	    function Response(body, _ref) {
	        var url = _ref.url;
	        var headers = _ref.headers;
	        var status = _ref.status;
	        var statusText = _ref.statusText;
	        classCallCheck(this, Response);
	
	
	        this.url = url;
	        this.body = body;
	        this.headers = headers || {};
	        this.status = status || 0;
	        this.statusText = statusText || '';
	        this.ok = status >= 200 && status < 300;
	    }
	
	    Response.prototype.text = function text() {
	        return this.body;
	    };
	
	    Response.prototype.blob = function blob() {
	        return new Blob([this.body]);
	    };
	
	    Response.prototype.json = function json() {
	        return JSON.parse(this.body);
	    };
	
	    return Response;
	}();
	
	var Request = function () {
	    function Request(options) {
	        classCallCheck(this, Request);
	
	
	        this.method = 'GET';
	        this.body = null;
	        this.params = {};
	        this.headers = {};
	
	        assign(this, options);
	    }
	
	    Request.prototype.getUrl = function getUrl() {
	        return Url(this);
	    };
	
	    Request.prototype.getBody = function getBody() {
	        return this.body;
	    };
	
	    Request.prototype.respondWith = function respondWith(body, options) {
	        return new Response(body, assign(options || {}, { url: this.getUrl() }));
	    };
	
	    return Request;
	}();
	
	/**
	 * Service for sending network requests.
	 */
	
	var CUSTOM_HEADERS = { 'X-Requested-With': 'XMLHttpRequest' };
	var COMMON_HEADERS = { 'Accept': 'application/json, text/plain, */*' };
	var JSON_CONTENT_TYPE = { 'Content-Type': 'application/json;charset=utf-8' };
	
	function Http(options) {
	
	    var self = this || {},
	        client = Client(self.$vm);
	
	    defaults(options || {}, self.$options, Http.options);
	
	    Http.interceptors.forEach(function (handler) {
	        client.use(handler);
	    });
	
	    return client(new Request(options)).then(function (response) {
	
	        return response.ok ? response : Promise$1.reject(response);
	    }, function (response) {
	
	        if (response instanceof Error) {
	            error(response);
	        }
	
	        return Promise$1.reject(response);
	    });
	}
	
	Http.options = {};
	
	Http.headers = {
	    put: JSON_CONTENT_TYPE,
	    post: JSON_CONTENT_TYPE,
	    patch: JSON_CONTENT_TYPE,
	    delete: JSON_CONTENT_TYPE,
	    custom: CUSTOM_HEADERS,
	    common: COMMON_HEADERS
	};
	
	Http.interceptors = [before, timeout, method, body, jsonp, header, cors];
	
	['get', 'delete', 'head', 'jsonp'].forEach(function (method) {
	
	    Http[method] = function (url, options) {
	        return this(assign(options || {}, { url: url, method: method }));
	    };
	});
	
	['post', 'put', 'patch'].forEach(function (method) {
	
	    Http[method] = function (url, body, options) {
	        return this(assign(options || {}, { url: url, method: method, body: body }));
	    };
	});
	
	function Resource(url, params, actions, options) {
	
	    var self = this || {},
	        resource = {};
	
	    actions = assign({}, Resource.actions, actions);
	
	    each(actions, function (action, name) {
	
	        action = merge({ url: url, params: params || {} }, options, action);
	
	        resource[name] = function () {
	            return (self.$http || Http)(opts(action, arguments));
	        };
	    });
	
	    return resource;
	}
	
	function opts(action, args) {
	
	    var options = assign({}, action),
	        params = {},
	        body;
	
	    switch (args.length) {
	
	        case 2:
	
	            params = args[0];
	            body = args[1];
	
	            break;
	
	        case 1:
	
	            if (/^(POST|PUT|PATCH)$/i.test(options.method)) {
	                body = args[0];
	            } else {
	                params = args[0];
	            }
	
	            break;
	
	        case 0:
	
	            break;
	
	        default:
	
	            throw 'Expected up to 4 arguments [params, body], got ' + args.length + ' arguments';
	    }
	
	    options.body = body;
	    options.params = assign({}, options.params, params);
	
	    return options;
	}
	
	Resource.actions = {
	
	    get: { method: 'GET' },
	    save: { method: 'POST' },
	    query: { method: 'GET' },
	    update: { method: 'PUT' },
	    remove: { method: 'DELETE' },
	    delete: { method: 'DELETE' }
	
	};
	
	function plugin(Vue) {
	
	    if (plugin.installed) {
	        return;
	    }
	
	    Util(Vue);
	
	    Vue.url = Url;
	    Vue.http = Http;
	    Vue.resource = Resource;
	    Vue.Promise = Promise$1;
	
	    Object.defineProperties(Vue.prototype, {
	
	        $url: {
	            get: function () {
	                return options(Vue.url, this, this.$options.url);
	            }
	        },
	
	        $http: {
	            get: function () {
	                return options(Vue.http, this, this.$options.http);
	            }
	        },
	
	        $resource: {
	            get: function () {
	                return Vue.resource.bind(this);
	            }
	        },
	
	        $promise: {
	            get: function () {
	                var _this = this;
	
	                return function (executor) {
	                    return new Vue.Promise(executor, _this);
	                };
	            }
	        }
	
	    });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(plugin);
	}
	
	module.exports = plugin;

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(5)
	__vue_script__ = __webpack_require__(9)
	__vue_template__ = __webpack_require__(11)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(6);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(8)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/sass-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./toast.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js!../../../node_modules/autoprefixer-loader/index.js!../../../node_modules/sass-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./toast.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(7)();
	// imports
	
	
	// module
	exports.push([module.id, ".toast-wrap{position:fixed;top:40%;left:50%;transform:translate3d(-50%,0,0);-moz-transform:translate3d(-50%,0,0);-webkit-transform:translate3d(-50%,0,0);-o-transform:translate3d(-50%,0,0);margin-left:auto;margin-right:auto;background-color:rgba(0,0,0,.7);color:#fff;text-align:center;padding:.4rem .42667rem;border-radius:.13333rem;font-size:.37333rem;line-height:1.4;z-index:10000}.toast-fade-enter-active,.toast-fade-leave-active{transition:opacity .5s}.toast-fade-enter,.toast-fade-leave-active{opacity:0}", ""]);
	
	// exports


/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Utils = __webpack_require__(10);
	
	var _Utils2 = _interopRequireDefault(_Utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// <template>
	//     <transition name="toast-fade">
	//         <div class="toast-wrap" v-show="showing">{{text}}</div>
	//     </transition>
	// </template>
	//
	// <script>
	var DEFAULT_DURATION = 3000;
	exports.default = {
	    name: 'toast',
	    data: function data() {
	        return {
	            text: '',
	            showing: false,
	            timer: null
	        };
	    },
	
	    ready: function ready() {
	        console.log('toast mounted...');
	        // 将公共方法注册到Utils中
	        _Utils2.default.register('toast', this.show);
	    },
	    methods: {
	        show: function show(text, duration, callback) {
	            var _this = this;
	
	            this.text = text;
	            this.showing = true;
	            if (this.timer) {
	                clearInterval(this.timer);
	            }
	            this.timer = setTimeout(function () {
	                _this.showing = false;
	                if (typeof callback == 'function') {
	                    callback();
	                }
	            }, duration || DEFAULT_DURATION);
	        }
	    }
	    // </script>
	    //
	    // <style type="sass">
	    //     @import "../../sass/base/_abbrev.scss";
	    //
	    //     .toast-wrap {
	    //         position: fixed;
	    //         top: 40%;
	    //         left: 50%;
	    //         transform: translate3d(-50%,0,0);
	    //         -moz-transform: translate3d(-50%,0,0);
	    //         -webkit-transform: translate3d(-50%,0,0);
	    //         -o-transform: translate3d(-50%,-0,0);
	    //         margin-left: auto;
	    //         margin-right: auto;
	    //         background-color: rgba(0, 0, 0, 0.7);
	    //         color: #ffffff;
	    //         text-align: center;
	    //         padding: rem(30) rem(32);
	    //         border-radius: rem(10);
	    //         font-size:rem(28);
	    //         line-height: 1.4;
	    //         z-index: 10000;
	    //     }
	    //     .toast-fade-enter-active, .toast-fade-leave-active {
	    //         transition: opacity .5s;
	    //     }
	    //     .toast-fade-enter, .toast-fade-leave-active {
	    //         opacity: 0;
	    //     }
	    // </style>
	
	    /* generated by vue-loader */
	
	};

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

	"use strict";
	
	var methods = {};
	
	module.exports = {
	  register: function register(name, func) {
	    methods[name] = func;
	  },
	  invoke: function invoke(name) {
	    var method = methods[name];
	    if (!method) return;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    method.apply(null, args);
	  }
	};

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	module.exports = " <transition name=toast-fade> <div class=toast-wrap v-show=showing>{{text}}</div> </transition> ";

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(17)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(20)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(18);
	var defined = __webpack_require__(19);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(21);
	var $export = __webpack_require__(22);
	var redefine = __webpack_require__(38);
	var hide = __webpack_require__(27);
	var Iterators = __webpack_require__(39);
	var $iterCreate = __webpack_require__(40);
	var setToStringTag = __webpack_require__(56);
	var getPrototypeOf = __webpack_require__(58);
	var ITERATOR = __webpack_require__(57)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),

/***/ 21:
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(23);
	var core = __webpack_require__(24);
	var ctx = __webpack_require__(25);
	var hide = __webpack_require__(27);
	var has = __webpack_require__(37);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.10' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(26);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),

/***/ 26:
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(28);
	var createDesc = __webpack_require__(36);
	module.exports = __webpack_require__(32) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(29);
	var IE8_DOM_DEFINE = __webpack_require__(31);
	var toPrimitive = __webpack_require__(35);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(32) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(30);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),

/***/ 30:
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(32) && !__webpack_require__(33)(function () {
	  return Object.defineProperty(__webpack_require__(34)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(33)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),

/***/ 33:
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(30);
	var document = __webpack_require__(23).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(30);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(27);


/***/ }),

/***/ 39:
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(41);
	var descriptor = __webpack_require__(36);
	var setToStringTag = __webpack_require__(56);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(27)(IteratorPrototype, __webpack_require__(57)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(29);
	var dPs = __webpack_require__(42);
	var enumBugKeys = __webpack_require__(54);
	var IE_PROTO = __webpack_require__(51)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(34)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(55).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(28);
	var anObject = __webpack_require__(29);
	var getKeys = __webpack_require__(43);
	
	module.exports = __webpack_require__(32) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(44);
	var enumBugKeys = __webpack_require__(54);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(37);
	var toIObject = __webpack_require__(45);
	var arrayIndexOf = __webpack_require__(48)(false);
	var IE_PROTO = __webpack_require__(51)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(46);
	var defined = __webpack_require__(19);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(47);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(45);
	var toLength = __webpack_require__(49);
	var toAbsoluteIndex = __webpack_require__(50);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(18);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(18);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(52)('keys');
	var uid = __webpack_require__(53);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(24);
	var global = __webpack_require__(23);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(21) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(23).document;
	module.exports = document && document.documentElement;


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(28).f;
	var has = __webpack_require__(37);
	var TAG = __webpack_require__(57)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(52)('wks');
	var uid = __webpack_require__(53);
	var Symbol = __webpack_require__(23).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(37);
	var toObject = __webpack_require__(59);
	var IE_PROTO = __webpack_require__(51)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(19);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(61);
	var global = __webpack_require__(23);
	var hide = __webpack_require__(27);
	var Iterators = __webpack_require__(39);
	var TO_STRING_TAG = __webpack_require__(57)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(62);
	var step = __webpack_require__(63);
	var Iterators = __webpack_require__(39);
	var toIObject = __webpack_require__(45);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(20)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),

/***/ 77:
/***/ (function(module, exports) {



/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(95);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(99);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _lux = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var self = module.exports; /**
	                            * Created by dongruihe on 2017/4/6.
	                            */
	
	self.isPhoneNumber = function (value) {
	    value = self.trim(value);
	    if (!value) return;
	    if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {} else {
	        return false;
	    }
	    return true;
	};
	self.trim = function (value) {
	    return value.replace(/\s+/g, "");
	};
	self.isNumber = function (value, length) {
	    value = self.trim(value);
	    var reg = new RegExp("^[0-9]*$");
	    if (length) {
	        if (!value || value.length != length || !reg.test(value)) return false;
	    } else {
	        if (!value || !reg.test(value)) return false;
	    }
	    return true;
	};
	self.idCard = function (str) {
	    var result = str.match(/\d{15}|\d{18}/);
	    if (result == null) {
	        return {
	            "result": false,
	            "message": '格式不正确'
	        };
	    } else {
	        return {
	            "result": true,
	            "message": ""
	        };
	    }
	};
	self.getParam = function (key) {
	    var s = location.search;
	    var params = s.substr(1, s.length);
	    var paramsArray = params.split('&');
	    var value = "";
	    for (var i = 0; i < paramsArray.length; i++) {
	        var paramArray = paramsArray[i].split('=');
	        if (paramArray[0] == key) {
	            value = paramArray[1];
	            // 后面的值覆盖前面的值
	        }
	    }
	    return value;
	};
	//获取客户端版本号
	self.getClientVersion = function () {
	    var ua = navigator.userAgent;
	    var reg = /\bxhqb\/([0-9.]+)/gi;
	    var matchArr = ua.match(reg);
	    var version = null;
	    if (matchArr && matchArr.length > 0) {
	        var temStr = matchArr[0];
	        var temArr = temStr.split('/');
	        version = temArr[1];
	    }
	    return version || '';
	};
	
	// 修改或增加链接带参数的值
	self.setUrlSearch = function (key, value) {
	    var s = location.search;
	    if (s == "") {
	        return "?" + key + "=" + value;
	    } else {
	        var params = s.substr(1, s.length);
	        var paramsArray = params.split('&');
	        var paramsValues = {};
	        var l = 0;
	        for (var i = 0; i < paramsArray.length; i++) {
	            var paramArray = paramsArray[i].split('=');
	            paramsValues[paramArray[0]] = paramArray[1];
	            l++;
	        }
	        if (paramsValues[key] == null) {
	            l++;
	        }
	        paramsValues[key] = value;
	        var newS = "?";
	        var c = 0;
	        for (var _i in paramsValues) {
	            newS += _i + "=" + paramsValues[_i] + "";
	            if (c < l - 1) {
	                newS += "&";
	            }
	            c++;
	        }
	        return newS;
	    }
	};
	self.goTo = function (url) {
	    window.location.href = url;
	};
	self.goBack = function () {
	    history.back();
	};
	self.changeTitle = function (pageTile) {
	    document.title = pageTile;
	    if (window.xhapp) {
	        xhapp.config({
	            debugNoBridge: false
	        });
	        xhapp.changeTitle({ title: pageTile }).then(function (rsp) {});
	    }
	};
	// 时间格式化
	self.dateFormat = function (timestamp) {
	    var simplify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var zero = function zero(value) {
	        if (value < 10) {
	            return '0' + value;
	        }
	        return value;
	    };
	
	    var myDate = timestamp ? new Date(timestamp) : new Date();
	    var year = myDate.getFullYear();
	    var month = zero(myDate.getMonth() + 1);
	    var day = zero(myDate.getDate());
	
	    var hour = zero(myDate.getHours());
	    var minite = zero(myDate.getMinutes());
	    var second = zero(myDate.getSeconds());
	
	    return simplify ? year + "\u5E74" + month + "\u6708" + day + "\u65E5" : year + '-' + month + '-' + day + ' ' + hour + ':' + minite + ':' + second;
	};
	
	self.showLoading = function () {
	    var loading = document.getElementById('loading');
	    if (loading) {
	        loading.style.display = 'block';
	    }
	};
	self.closeLoading = function () {
	    var loading = document.getElementById('loading');
	    var app = document.getElementById('app');
	    if (loading) {
	        loading.style.display = 'none';
	    }
	    if (app) {
	        app.style.display = 'block';
	    }
	};
	
	self.isWeiXin = function () {
	    var ua = window.navigator.userAgent.toLowerCase();
	    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
	        return true;
	    } else {
	        return false;
	    }
	};
	self.getParam = function (name) {
	    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	    var r = window.location.search.substr(1).match(reg);
	    if (r != null) {
	        return unescape(r[2]);
	    }
	    return '';
	};
	self.storage = {
	    set: function set(name, val, options) {
	        var options = options || {};
	        if (options.session && window.sessionStorage) {
	            window.sessionStorage.setItem(name, (0, _stringify2.default)(val));
	        } else if (window.localStorage) {
	            window.localStorage.setItem(name, (0, _stringify2.default)(val));
	        } else {
	            $.cookie(name, val, options);
	        }
	    },
	    get: function get(name, options) {
	        var options = options || {};
	        if (options.session && window.sessionStorage) {
	            return JSON.parse(window.sessionStorage.getItem(name) || null);
	        } else if (window.localStorage) {
	            return JSON.parse(window.localStorage.getItem(name) || null);
	        } else {
	            return $.cookie(name);
	        }
	    },
	    clear: function clear(name, options) {
	        var options = options || {};
	        if (options.session && window.sessionStorage) {
	            window.sessionStorage.removeItem(name);
	        } else if (window.localStorage) {
	            window.localStorage.removeItem(name);
	        } else {
	            $.removeCookie(name, options);
	        }
	    }
	};
	//验证身份证号码
	self.verifyIdcard = function (idcard) {
	    if (idcard == "") {
	        return true;
	    }
	    var regex1 = /^[1-9][0-7]\d{4}((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))0229))\d{3}(\d|X|x)?$/;
	    /*身份号码位数及格式检验*/
	    switch (idcard.length) {
	        case 15:
	            if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0 || (parseInt(idcard.substr(6, 2)) + 1900) % 100 == 0 && (parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0) {
	                var regex2 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/; //测试出生日期的合法性
	            } else {
	                var regex2 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/; //测试出生日期的合法性
	            }
	            if (regex2.test(idcard)) return true;else return false;
	            break;
	        case 18:
	            if (regex1.test(idcard)) {
	                var S = (parseInt(idcard.charAt(0)) + parseInt(idcard.charAt(10))) * 7 + (parseInt(idcard.charAt(1)) + parseInt(idcard.charAt(11))) * 9 + (parseInt(idcard.charAt(2)) + parseInt(idcard.charAt(12))) * 10 + (parseInt(idcard.charAt(3)) + parseInt(idcard.charAt(13))) * 5 + (parseInt(idcard.charAt(4)) + parseInt(idcard.charAt(14))) * 8 + (parseInt(idcard.charAt(5)) + parseInt(idcard.charAt(15))) * 4 + (parseInt(idcard.charAt(6)) + parseInt(idcard.charAt(16))) * 2 + parseInt(idcard.charAt(7)) * 1 + parseInt(idcard.charAt(8)) * 6 + parseInt(idcard.charAt(9)) * 3;
	                var Y = S % 11;
	                var M = "F";
	                var JYM = "10X98765432";
	                M = JYM.substr(Y, 1);
	                /*判断校验位*/
	                if (M == idcard.charAt(17).toUpperCase()) {
	                    return true;
	                } else {
	                    return false;
	                }
	            } else {
	                return false;
	            }
	            break;
	        default:
	            return false;
	    }
	};
	
	// 底部添加备案号
	self.addICP = function (selector) {
	    var text = '';
	    var s = document.querySelector(selector);
	    if (location.host.indexOf('xhqbapp.com') >= 0) {
	        text = '沪ICP备20014574号-1';
	    } else if (location.host.indexOf('xiaohuaqb.com') >= 0) {
	        text = '沪ICP备20014574号-8';
	    } else if (location.host.indexOf('truechine.com') >= 0) {
	        text = '沪ICP备2020027929号-2';
	    } else if (location.host.indexOf('xhzhw.com') >= 0) {
	        text = '沪ICP备20014574号-2';
	    } else if (location.host.indexOf('xhqb.com') >= 0) {
	        text = '粤ICP备2021018097号';
	    }
	    if (s) {
	        s.appendChild(document.createElement('br'));
	        s.appendChild(document.createTextNode(text));
	    }
	};
	
	/**
	 * 分割出一级域名
	 * @param {string} val - 二级域名，例：www.xhqb.com
	 * @returns {string} - 一级域名，返回 xhqb.com
	 */
	self.splitHost = function (val) {
	    if (!val) return '';
	    var arr = val.split('.');
	    arr.shift();
	    return arr.join('.');
	};
	
	// 获取 XHQB
	function getBrowserXhqb() {
	    var userAgent = window.navigator.userAgent;
	    var browserName = '';
	    if (userAgent.includes('XHQB')) {
	        browserName = 'XHQB';
	    }
	    if (userAgent.includes('XHQBJSB')) {
	        browserName = 'XHQBJSB';
	    }
	
	    return browserName;
	}
	
	function isApp() {
	    return getBrowserXhqb() === 'XHQB' || getBrowserXhqb() === 'XHQBJSB';
	}
	
	self.isAddGw = function () {
	    var userAgent = window.navigator.userAgent;
	    if (userAgent.includes('XHQB') || userAgent.includes('XHQBJSB')) {
	        // 在Android端 && app版本大于等于5.22.0
	        var version = _lux.useragent.getVersion('XHQB');
	        if (_lux.useragent.isAndroid() && _lux.useragent.compareVersion(version, '5.22.0') >= 0) {
	            return true;
	        }
	        return false;
	    } else {
	        return true;
	    }
	};
	
	// 区分设备
	self.getOsTypeLower = function () {
	    if (isApp()) {
	        if (_lux.useragent.isAndroid()) {
	            return 'Android';
	        } else if (_lux.useragent.isIos()) {
	            return 'iOS';
	        }
	    }
	    return 'WAP';
	};
	
	/**
	 * formdata表单请求跳转招行签约
	 * @returns
	 */
	self.handleFormData = function (formParams, formUrl, formId) {
	    var form = document.createElement('form');
	    form.setAttribute('id', formId);
	    form.setAttribute('method', 'post');
	    form.setAttribute('action', formUrl);
	    (0, _keys2.default)(formParams).forEach(function (name) {
	        var value = formParams[name];
	        var inputElelment = document.createElement('input');
	        inputElelment.setAttribute('type', 'hidden');
	        inputElelment.setAttribute('name', name);
	        inputElelment.setAttribute('value', value);
	        form.appendChild(inputElelment);
	    });
	    document.documentElement.appendChild(form);
	    form.submit();
	    document.documentElement.removeChild(form);
	};

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(96), __esModule: true };

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97);
	module.exports = __webpack_require__(24).Object.keys;


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(59);
	var $keys = __webpack_require__(43);
	
	__webpack_require__(98)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(22);
	var core = __webpack_require__(24);
	var fails = __webpack_require__(33);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(100), __esModule: true };

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(24);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.lux = {}));
	})(this, (function (exports) { 'use strict';
	
	  /**
	   * 格式化银行卡号
	   *
	   * @export
	   * @param {string} cardNum
	   * @returns {string}
	   */
	  function creditCard(cardNum, mask) {
	      var newCardNum = cardNum
	          .replace(/\s/g, '')
	          .replace(/[^\d]/g, '')
	          .replace(/(\d{4})(?=\d)/g, '$1 ');
	      return mask ? newCardNum.replace(/\s(\d{4})(?!\d)/g, ' ****') : newCardNum;
	  }
	  /**
	   * 格式化手机号
	   *
	   * @export
	   * @param {string} phoneNum
	   * @returns {string}
	   */
	  function phoneNumber(phoneNum, mask) {
	      var newPhoneNum = phoneNum
	          .replace(/\s/g, '')
	          .replace(/[^\d]/g, '')
	          .replace(/(\d{3})(\d{4})(?=\d)/g, '$1 $2 ');
	      return mask ? newPhoneNum.replace(/\s(\d{4})\s/g, ' **** ') : newPhoneNum;
	  }
	  // 格式化身份证号
	  function formatIdentity(data) {
	      if (!data) {
	          return null;
	      }
	      var cardNum = data.replace(data.slice(2, -3), '*************');
	      return cardNum;
	  }
	  // 格式化名字
	  function formatName(data) {
	      if (!data) {
	          return null;
	      }
	      if (data.length < 3) {
	          return data.slice(0, 1) + '*';
	      }
	      return data.slice(0, -2) + '**';
	  }
	  /**
	   * 格式化数字，添加千位分隔符
	   *
	   * @export
	   * @param {(string | number)} num
	   * @returns {string}
	   */
	  function number(num) {
	      var numStr = String(num);
	      var int = numStr.split('.')[0];
	      var decimal = numStr.split('.')[1];
	      return (int
	          .replace(/\s/g, '')
	          .replace(/[^\d]/g, '')
	          .replace(/(?!^)(?=(\d{3})+$)/g, ',') + (decimal ? '.' + decimal : ''));
	  }
	  // 格式化小数点
	  function formatToFixed(data, point) {
	      if (!data)
	          return;
	      return data.toFixed(point);
	  }
	  //校验身份证号
	  function verifyIdcard(idcard) {
	      if (idcard === '') {
	          return true;
	      }
	      var regex1 = /^[1-9][0-7]\d{4}((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))0229))\d{3}(\d|X|x)?$/;
	      /* 身份号码位数及格式检验 */
	      switch (idcard.length) {
	          case 15:
	              if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0 ||
	                  ((parseInt(idcard.substr(6, 2)) + 1900) % 100 === 0 &&
	                      (parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0)) {
	                  var regex2_1 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/; // 测试出生日期的合法性
	                  if (regex2_1.test(idcard)) {
	                      return true;
	                  }
	                  return false;
	              }
	              // eslint-disable-next-line
	              var regex2 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/; // 测试出生日期的合法性
	              if (regex2.test(idcard)) {
	                  return true;
	              }
	              return false;
	          case 18:
	              if (regex1.test(idcard)) {
	                  var S = (parseInt(idcard.charAt(0)) + parseInt(idcard.charAt(10))) * 7 +
	                      (parseInt(idcard.charAt(1)) + parseInt(idcard.charAt(11))) * 9 +
	                      (parseInt(idcard.charAt(2)) + parseInt(idcard.charAt(12))) * 10 +
	                      (parseInt(idcard.charAt(3)) + parseInt(idcard.charAt(13))) * 5 +
	                      (parseInt(idcard.charAt(4)) + parseInt(idcard.charAt(14))) * 8 +
	                      (parseInt(idcard.charAt(5)) + parseInt(idcard.charAt(15))) * 4 +
	                      (parseInt(idcard.charAt(6)) + parseInt(idcard.charAt(16))) * 2 +
	                      parseInt(idcard.charAt(7)) * 1 +
	                      parseInt(idcard.charAt(8)) * 6 +
	                      parseInt(idcard.charAt(9)) * 3;
	                  var Y = S % 11;
	                  var M = 'F';
	                  var JYM = '10X98765432';
	                  M = JYM.substr(Y, 1);
	                  /* 判断校验位 */
	                  if (M === idcard.charAt(17).toUpperCase()) {
	                      return true;
	                  }
	                  return false;
	              }
	              break;
	          default:
	              return false;
	      }
	  }
	  // 格式化将数字金额转换成大写中文
	  function famatterNumToChinese(moneyString) {
	      var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
	      var cnIntRadice = ['', '拾', '佰', '仟'];
	      var cnIntUnits = ['', '万', '亿', '兆'];
	      var cnDecUnits = ['角', '分', '毫', '厘'];
	      var cnInteger = '整';
	      var cnIntLast = '元';
	      var maxNum = 999999999999999.9999;
	      var IntegerNum;
	      var DecimalNum;
	      var ChineseStr = '';
	      var parts;
	      if (moneyString === '') {
	          return '';
	      }
	      var money = parseFloat(moneyString);
	      if (money >= maxNum) {
	          return '';
	      }
	      if (money === 0) {
	          ChineseStr = cnNums[0] + cnIntLast + cnInteger;
	          return ChineseStr;
	      }
	      money = money.toString();
	      if (money.indexOf('.') === -1) {
	          IntegerNum = money;
	          DecimalNum = '';
	      }
	      else {
	          parts = money.split('.');
	          IntegerNum = parts[0];
	          DecimalNum = parts[1].substr(0, 4);
	      }
	      if (parseInt(IntegerNum) > 0) {
	          var zeroCount = 0;
	          var IntLen = IntegerNum.length;
	          for (var index = 0; index < IntLen; index++) {
	              var n = IntegerNum.substr(index, 1);
	              var p = IntLen - index - 1;
	              var q = p / 4;
	              var m = p % 4;
	              if (n === '0') {
	                  zeroCount++;
	              }
	              else {
	                  if (zeroCount > 0) {
	                      ChineseStr += cnNums[0];
	                  }
	                  // 归零
	                  zeroCount = 0;
	                  ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
	              }
	              if (m === 0 && zeroCount < 4) {
	                  ChineseStr += cnIntUnits[q];
	              }
	          }
	          ChineseStr += cnIntLast;
	      }
	      if (DecimalNum !== '') {
	          var decLen = DecimalNum.length;
	          for (var index = 0; index < decLen; index++) {
	              var n = DecimalNum.substr(index, 1);
	              if (n !== '0') {
	                  ChineseStr += cnNums[Number(n)] + cnDecUnits[index];
	              }
	          }
	      }
	      if (ChineseStr === '') {
	          ChineseStr += cnNums[0] + cnIntLast + cnInteger;
	      }
	      else if (DecimalNum === '') {
	          ChineseStr += cnInteger;
	      }
	      return ChineseStr;
	  }
	
	  var index$3 = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    creditCard: creditCard,
	    phoneNumber: phoneNumber,
	    formatIdentity: formatIdentity,
	    formatName: formatName,
	    number: number,
	    formatToFixed: formatToFixed,
	    verifyIdcard: verifyIdcard,
	    famatterNumToChinese: famatterNumToChinese
	  });
	
	  /*! *****************************************************************************
	  Copyright (c) Microsoft Corporation.
	
	  Permission to use, copy, modify, and/or distribute this software for any
	  purpose with or without fee is hereby granted.
	
	  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	  PERFORMANCE OF THIS SOFTWARE.
	  ***************************************************************************** */
	
	  var __assign = function() {
	      __assign = Object.assign || function __assign(t) {
	          for (var s, i = 1, n = arguments.length; i < n; i++) {
	              s = arguments[i];
	              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	          }
	          return t;
	      };
	      return __assign.apply(this, arguments);
	  };
	
	  function __awaiter(thisArg, _arguments, P, generator) {
	      function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	      return new (P || (P = Promise))(function (resolve, reject) {
	          function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	          function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	          function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	          step((generator = generator.apply(thisArg, _arguments || [])).next());
	      });
	  }
	
	  function __generator(thisArg, body) {
	      var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	      function verb(n) { return function (v) { return step([n, v]); }; }
	      function step(op) {
	          if (f) throw new TypeError("Generator is already executing.");
	          while (_) try {
	              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	              if (y = 0, t) op = [op[0] & 2, t.value];
	              switch (op[0]) {
	                  case 0: case 1: t = op; break;
	                  case 4: _.label++; return { value: op[1], done: false };
	                  case 5: _.label++; y = op[1]; op = [0]; continue;
	                  case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                  default:
	                      if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                      if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                      if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                      if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                      if (t[2]) _.ops.pop();
	                      _.trys.pop(); continue;
	              }
	              op = body.call(thisArg, _);
	          } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	          if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	      }
	  }
	
	  function __spreadArrays() {
	      for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	      for (var r = Array(s), k = 0, i = 0; i < il; i++)
	          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	              r[k] = a[j];
	      return r;
	  }
	
	  function getQueryParam(url) {
	      var search = url.split('?')[1];
	      var result = {};
	      if (search) {
	          var params = search.split('&');
	          params.forEach(function (paramString) {
	              var param = paramString.split('=');
	              var key = param[0];
	              var value = decodeURIComponent(param[1]);
	              result[key] = value;
	          });
	      }
	      return result;
	  }
	  /**
	   * 解析 URL
	   *
	   * @export
	   * @param {string} url
	   * @returns {UrlMeta}
	   */
	  function parse(url) {
	      var parsedUrl = new URL(url);
	      var params = getQueryParam(parsedUrl.search);
	      return __assign(__assign({}, parsedUrl), { params: params });
	  }
	  /**
	   * 获取 url 中 query 参数
	   *
	   * @export
	   * @param {string} name
	   * @returns {string}
	   */
	  function getSearchParam(name) {
	      var params = parse(window.location.href).params;
	      return params[name];
	  }
	  /**
	   * json 数据转 url 参数
	   *
	   * @export
	   * @param {Params} params
	   * @returns {string}
	   */
	  function toQueryString(params) {
	      return params
	          ? Object.keys(params)
	              .map(function (key) {
	              return key + "=" + encodeURIComponent(params[key].toString());
	          })
	              .join('&')
	          : '';
	  }
	  /**
	   * url 拼接新参数
	   *
	   * @export
	   * @param {string} url
	   * @param {Params<any>} params
	   * @returns {string}
	   */
	  function addSearchParam(url, params) {
	      return url + (url.indexOf('?') === -1 ? '?' : '&') + toQueryString(params);
	  }
	
	  var index$2 = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    parse: parse,
	    getSearchParam: getSearchParam,
	    toQueryString: toQueryString,
	    addSearchParam: addSearchParam
	  });
	
	  var rule = {
	      string: function (arg) { return typeof arg === 'string'; },
	      number: function (arg) { return typeof arg === 'number'; },
	      null: function (arg) { return !arg && typeof arg !== 'undefined' && arg !== 0; },
	      undefined: function (arg) { return typeof arg === 'undefined'; },
	      array: function (arg) { return Array.isArray(arg); },
	      object: function (arg) {
	          return typeof arg === 'object' &&
	              Object.prototype.toString.call(arg) === '[object Object]';
	      },
	      url: function (url) {
	          return /(http|ftp|https|ws|wss):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/.test(url);
	      },
	      email: function (email) {
	          return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(email);
	      },
	      phone: function (phone) {
	          // 2022.2.14 修改手机号规则，前端手机号只做简单校验，11位数字，1开头
	          return /^1[3456789]\d{9}$/.test(phone);
	      },
	      identity: function (id) {
	          if (id.length !== 18)
	              return false;
	          var cityNo = {
	              11: '北京',
	              12: '天津',
	              13: '河北',
	              14: '山西',
	              15: '内蒙古',
	              21: '辽宁',
	              22: '吉林',
	              23: '黑龙江',
	              31: '上海',
	              32: '江苏',
	              33: '浙江',
	              34: '安徽',
	              35: '福建',
	              36: '江西',
	              37: '山东',
	              41: '河南',
	              42: '湖北',
	              43: '湖南',
	              44: '广东',
	              45: '广西',
	              46: '海南',
	              50: '重庆',
	              51: '四川',
	              52: '贵州',
	              53: '云南',
	              54: '西藏',
	              61: '陕西',
	              62: '甘肃',
	              63: '青海',
	              64: '宁夏',
	              65: '新疆',
	              71: '台湾',
	              81: '香港',
	              82: '澳门',
	              91: '国外'
	          };
	          var province = id.substr(0, 2);
	          if (!cityNo[province])
	              return false;
	          var regexp = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
	          var match = id.match(regexp);
	          var year = Number(match[2]);
	          var month = Number(match[3]);
	          var date = Number(match[4]);
	          var birthday = new Date(year, month - 1, date);
	          var isValidBirthday = birthday.getFullYear() === year &&
	              birthday.getMonth() + 1 === month &&
	              birthday.getDate() === date;
	          if (!isValidBirthday)
	              return false;
	          var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
	          var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
	          var cardTemp = 0;
	          var valnum;
	          for (var i = 0; i < 17; i++) {
	              cardTemp += Number(id.substr(i, 1)) * arrInt[i];
	          }
	          valnum = arrCh[cardTemp % 11];
	          if (valnum !== id.substr(17, 1).toLocaleUpperCase())
	              return false;
	          return true;
	      },
	      creditCard: function (card) {
	          if (!/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/.test(card))
	              return false;
	          var sum = 0;
	          var digit;
	          var tmpNum;
	          var shouldDouble;
	          for (var i = card.length - 1; i >= 0; i--) {
	              digit = card.substr(i, 1);
	              tmpNum = Number(digit);
	              if (shouldDouble) {
	                  tmpNum *= 2;
	                  if (tmpNum >= 10) {
	                      sum += (tmpNum % 10) + 1;
	                  }
	                  else {
	                      sum += tmpNum;
	                  }
	              }
	              else {
	                  sum += tmpNum;
	              }
	              shouldDouble = !shouldDouble;
	          }
	          return !!(sum % 10 === 0 ? card : false);
	      },
	      contains: function (arg, value) {
	          if (typeof arg === 'string' && typeof value === 'string') {
	              return arg.includes(value);
	          }
	          if (Array.isArray(arg)) {
	              return arg.includes(value);
	          }
	          if (rule.object(arg) && typeof value === 'string') {
	              return Object.keys(arg).includes(value);
	          }
	      },
	      empty: function (arg) {
	          if (rule.string(arg))
	              return arg === '';
	          if (rule.array(arg))
	              return arg.length === 0;
	          if (rule.object(arg))
	              return Object.keys(arg).length === 0;
	          if (rule.undefined(arg) || rule.null(arg))
	              return true;
	          return false;
	      },
	      not: function (arg1, arg2) { return arg1 !== arg2; },
	      eq: function (arg1, arg2) { return arg1 === arg2; },
	      gt: function (arg1, arg2) {
	          return Number(arg1) > Number(arg2);
	      },
	      gte: function (arg1, arg2) {
	          return Number(arg1) >= Number(arg2);
	      },
	      lt: function (arg1, arg2) {
	          return Number(arg1) < Number(arg2);
	      },
	      lte: function (arg1, arg2) {
	          return Number(arg1) <= Number(arg2);
	      },
	      //校验身份证号是否合规
	      verifyIdcard: function (idcard) {
	          if (idcard === '') {
	              return true;
	          }
	          var regex1 = /^[1-9][0-7]\d{4}((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))0229))\d{3}(\d|X|x)?$/;
	          /* 身份号码位数及格式检验 */
	          switch (idcard.length) {
	              case 15:
	                  if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0 ||
	                      ((parseInt(idcard.substr(6, 2)) + 1900) % 100 === 0 &&
	                          (parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0)) {
	                      var regex2_1 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/; // 测试出生日期的合法性
	                      if (regex2_1.test(idcard)) {
	                          return true;
	                      }
	                      return false;
	                  }
	                  // eslint-disable-next-line
	                  var regex2 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/; // 测试出生日期的合法性
	                  if (regex2.test(idcard)) {
	                      return true;
	                  }
	                  return false;
	              case 18:
	                  if (regex1.test(idcard)) {
	                      var S = (parseInt(idcard.charAt(0)) + parseInt(idcard.charAt(10))) * 7 +
	                          (parseInt(idcard.charAt(1)) + parseInt(idcard.charAt(11))) * 9 +
	                          (parseInt(idcard.charAt(2)) + parseInt(idcard.charAt(12))) * 10 +
	                          (parseInt(idcard.charAt(3)) + parseInt(idcard.charAt(13))) * 5 +
	                          (parseInt(idcard.charAt(4)) + parseInt(idcard.charAt(14))) * 8 +
	                          (parseInt(idcard.charAt(5)) + parseInt(idcard.charAt(15))) * 4 +
	                          (parseInt(idcard.charAt(6)) + parseInt(idcard.charAt(16))) * 2 +
	                          parseInt(idcard.charAt(7)) * 1 +
	                          parseInt(idcard.charAt(8)) * 6 +
	                          parseInt(idcard.charAt(9)) * 3;
	                      var Y = S % 11;
	                      var M = 'F';
	                      var JYM = '10X98765432';
	                      M = JYM.substr(Y, 1);
	                      /* 判断校验位 */
	                      if (M === idcard.charAt(17).toUpperCase()) {
	                          return true;
	                      }
	                      return false;
	                  }
	                  break;
	              default:
	                  return false;
	          }
	      }
	  };
	
	  var Validator = /** @class */ (function () {
	      function Validator(value) {
	          this.value = value;
	          this.passed = true;
	          this.message = 'passed';
	      }
	      Validator.prototype.data = function (value) {
	          this.value = value;
	          return this;
	      };
	      Validator.prototype.required = function (message, callback) {
	          if (!this.passed)
	              return this;
	          if (!this.value) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.minLength = function (length, message, callback) {
	          if (!this.passed)
	              return this;
	          if (rule.lt(this.value.toString().length, length)) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.maxLength = function (length, message, callback) {
	          if (!this.passed)
	              return this;
	          if (rule.gt(this.value.toString().length, length)) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.equals = function (data, message, callback) {
	          if (!this.passed)
	              return this;
	          if (rule.not(this.value, data)) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.range = function (range, message, callback) {
	          if (!this.passed)
	              return this;
	          if (rule.lt(this.value, range[0]) || rule.gt(this.value, range[1])) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.regexp = function (reg, message, callback) {
	          if (!this.passed)
	              return this;
	          if (!reg.test(this.value.toString())) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.phone = function (message, callback) {
	          if (!this.passed)
	              return this;
	          if (!rule.phone(this.value.toString())) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.identity = function (message, callback) {
	          if (!this.passed)
	              return this;
	          if (!rule.identity(this.value.toString())) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.contains = function (value, message, callback) {
	          if (!this.passed)
	              return this;
	          if (!rule.contains(this.value, value)) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.lte = function (value, message, callback) {
	          if (!this.passed)
	              return this;
	          if (!rule.lte(this.value, value)) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.lt = function (value, message, callback) {
	          if (!this.passed)
	              return this;
	          if (!rule.lt(this.value, value)) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.gte = function (value, message, callback) {
	          if (!this.passed)
	              return this;
	          if (!rule.gte(this.value, value)) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.gt = function (value, message, callback) {
	          if (!this.passed)
	              return this;
	          if (!rule.gt(this.value, value)) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      Validator.prototype.exec = function (method, message, params, callback) {
	          if (params === void 0) { params = []; }
	          if (!this.passed)
	              return this;
	          var result = method.apply(void 0, __spreadArrays([this.value], params));
	          if (!result) {
	              this.message = message;
	              this.passed = false;
	          }
	          callback && callback(this);
	          return this;
	      };
	      return Validator;
	  }());
	
	  var index$1 = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    'default': Validator
	  });
	
	  function getOS() {
	      var ua = navigator.userAgent;
	      var os = {
	          name: 'unknown',
	          version: 'unknown'
	      };
	      if (ua.includes('Android') || ua.includes('Adr')) {
	          os.name = 'android';
	          os.version = ua.match(/Android ([\w.]+)/)[1];
	      }
	      else if (ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
	          os.name = 'ios';
	          if (ua.includes('iPad')) {
	              os.version = ua.match(/CPU OS ([\w_]+)/)[1].replace('_', '.');
	          }
	          else {
	              os.version = ua.match(/iPhone OS ([\w_]+)/)[1].replace('_', '.');
	          }
	      }
	      else if (ua.includes('mac os x')) {
	          os.name = 'mac';
	          os.version = ua.match(/Mac OS X ([\w_]+)/)[1].replace('_', '.');
	      }
	      else if (ua.includes('Windows NT')) {
	          os.name = 'windows';
	          os.version = ua.match(/Windows NT ([\w_]+)/)[1];
	      }
	      return os;
	  }
	  function judgeBrand() {
	      var ua = navigator.userAgent.toLowerCase();
	      var isHuawei = ua.includes('huawei');
	      var isHonor = ua.includes('honor');
	      var isOppo = ua.includes('oppo');
	      var isOppoR15 = ua.includes('pacm00');
	      var isRno4 = ua.includes('pdpm00');
	      var isRno3 = ua.includes('pclm50');
	      var isVivo = ua.includes('vivo');
	      var isVivo3 = ua.includes('v1938ct');
	      var isXiaomi = ua.includes('mi');
	      var isXiaomi2s = ua.includes('mix');
	      var isRedmi = ua.includes('redmi');
	      var isSamsung = ua.includes('sm-');
	      var isMz = ua.includes('mz');
	      var isMeizu = ua.includes('mzb');
	      var isMeizuqq = ua.includes('mqqb');
	      var isMx = ua.includes('mx');
	      var isMzNote = ua.includes('m1822');
	      if (isHuawei || isHonor) {
	          return 'huawei';
	      }
	      if (isOppo || isOppoR15 || isRno4 || isRno3) {
	          return 'oppo';
	      }
	      if (isVivo || isVivo3) {
	          return 'vivo';
	      }
	      if (isXiaomi || isRedmi || isXiaomi2s) {
	          return 'xiaomi';
	      }
	      if (isSamsung) {
	          return 'samsung';
	      }
	      if (isMeizu || isMz || isMeizuqq || isMx || isMzNote) {
	          return 'meizu';
	      }
	      return 'default';
	  }
	  function getBrowser() {
	      var ua = navigator.userAgent;
	      var browser = {
	          name: 'unknown',
	          version: 'unknown'
	      };
	      if (ua.includes('MicroMessenger')) {
	          browser.name = 'wechat';
	          browser.version = getVersion('MicroMessenger');
	      }
	      else if (ua.includes('QQ')) {
	          browser.name = 'qq';
	          browser.version = getVersion('QQ');
	      }
	      else if (ua.includes('ucweb') || ua.includes('UCBrowser')) {
	          browser.name = 'uc';
	          browser.version = 'uc';
	      }
	      else if (ua.includes('Safari')) {
	          browser.name = 'safari';
	          browser.version = getVersion('Safari');
	      }
	      else if (ua.includes('Chrome')) {
	          browser.name = 'chrome';
	          browser.version = getVersion('Chrome');
	      }
	      return browser;
	  }
	  function isWechat() {
	      return getBrowser().name === 'wechat';
	  }
	  function isQQ() {
	      return getBrowser().name === 'qq';
	  }
	  function isAndroid() {
	      return getOS().name === 'android';
	  }
	  function isIos() {
	      return getOS().name === 'ios';
	  }
	  function isOppo() {
	      return judgeBrand() === 'oppo';
	  }
	  function isVivo() {
	      return judgeBrand() === 'vivo';
	  }
	  function isHuawei() {
	      return judgeBrand() === 'huawei';
	  }
	  function isXiaomi() {
	      return judgeBrand() === 'xiaomi';
	  }
	  function isSamsung() {
	      return judgeBrand() === 'samsung';
	  }
	  function isMeizu() {
	      return judgeBrand() === 'meizu';
	  }
	  //获取APP版本号
	  function getVersion(name) {
	      var ua = navigator.userAgent;
	      var reg = new RegExp(name + "/([\\w.]+)");
	      if (reg.test(ua))
	          return ua.match(reg)[1];
	  }
	  function iosVerion(num) {
	      var ua = window.navigator.userAgent.toLowerCase();
	      // if (ua.indexOf('like mac os x') > 0) {
	      var reg = /os [\d._]*/gi;
	      var verinfo = ua.match(reg);
	      var version = String(verinfo)
	          .replace(/[^0-9|_.]/gi, '')
	          .replace(/_/gi, '.');
	      // console.log('version', version)
	      var arr = version.split('.');
	      // console.log('arr', arr)
	      var versionNum = Number(arr[0]);
	      if (versionNum >= num) {
	          // console.log('15')
	          return true;
	      }
	      // console.log('15以下')
	      return false;
	      // }
	  }
	  /**
	   * 版本号比较进阶版
	   * ver1  前一个版本
	   * ver2  后一个版本
	   *  **/
	  function compareVersion(ver1, ver2) {
	      var v1 = ver1.split('.');
	      var v2 = ver2.split('.');
	      var len = Math.max(v1.length, v2.length);
	      // 调整两个版本号位数相同
	      while (v1.length < len) {
	          v1.push('0');
	      }
	      while (v2.length < len) {
	          v2.push('0');
	      }
	      // 循环判断每位数的大小
	      for (var i = 0; i < len; i++) {
	          var num1 = parseInt(v1[i]);
	          var num2 = parseInt(v2[i]);
	          if (num1 > num2) {
	              //前一个版本 大于 后一个版本
	              return 1;
	          }
	          else if (num1 < num2) {
	              //前一个版本 小于 后一个版本
	              return -1;
	          }
	      }
	      return 0;
	  }
	
	  var index = /*#__PURE__*/Object.freeze({
	    __proto__: null,
	    getOS: getOS,
	    judgeBrand: judgeBrand,
	    getBrowser: getBrowser,
	    isWechat: isWechat,
	    isQQ: isQQ,
	    isAndroid: isAndroid,
	    isIos: isIos,
	    isOppo: isOppo,
	    isVivo: isVivo,
	    isHuawei: isHuawei,
	    isXiaomi: isXiaomi,
	    isSamsung: isSamsung,
	    isMeizu: isMeizu,
	    getVersion: getVersion,
	    iosVerion: iosVerion,
	    compareVersion: compareVersion
	  });
	
	  var SessionStore = /** @class */ (function () {
	      function SessionStore() {
	      }
	      SessionStore.prototype.set = function (key, value) {
	          window.sessionStorage.setItem(key, JSON.stringify(value));
	      };
	      // eslint-disable-next-line @typescript-eslint/promise-function-async
	      SessionStore.prototype.get = function (key) {
	          var value = window.sessionStorage.getItem(key);
	          return value ? JSON.parse(value) : null;
	      };
	      SessionStore.prototype.remove = function (key) {
	          window.sessionStorage.removeItem(key);
	      };
	      SessionStore.prototype.clear = function () {
	          window.sessionStorage.clear();
	      };
	      return SessionStore;
	  }());
	
	  var LocalStore = /** @class */ (function () {
	      function LocalStore() {
	      }
	      LocalStore.prototype.set = function (key, value, expires) {
	          if (expires) {
	              this.set("__expires_" + key + "__", Date.now() + expires);
	          }
	          window.localStorage.setItem(key, JSON.stringify(value));
	      };
	      // eslint-disable-next-line @typescript-eslint/promise-function-async
	      LocalStore.prototype.get = function (key) {
	          var expired = window.localStorage.getItem("__expires_" + key + "__");
	          if (expired && JSON.parse(expired) < Date.now()) {
	              this.remove(key);
	              this.remove("__expires_" + key + "__");
	              return null;
	          }
	          var value = window.localStorage.getItem(key);
	          return value ? JSON.parse(value) : null;
	      };
	      LocalStore.prototype.remove = function (key) {
	          window.localStorage.removeItem(key);
	      };
	      LocalStore.prototype.clear = function () {
	          window.localStorage.clear();
	      };
	      return LocalStore;
	  }());
	
	  var sessionStore = new SessionStore();
	  var localStore = new LocalStore();
	
	  var cache = {};
	  function dynamicLoad(url) {
	      return __awaiter(this, void 0, void 0, function () {
	          return __generator(this, function (_a) {
	              if (cache[url])
	                  return [2 /*return*/];
	              return [2 /*return*/, new Promise(function (resolve, reject) {
	                      var script = document.createElement('script');
	                      script.type = 'text/javascript';
	                      script.src = url;
	                      script.addEventListener('load', function () {
	                          cache[url] = true;
	                          resolve();
	                      });
	                      script.addEventListener('error', function (error) {
	                          reject(error);
	                      });
	                      document.body.appendChild(script);
	                  })];
	          });
	      });
	  }
	
	  /**
	   * 根据域名切换备案号
	   *
	   * @export
	   * @returns {ResponseICP}
	   */
	  function modifyICP() {
	      var host = window.location.hostname;
	      var obj = {
	          'www.xhqb.com': {
	              company: '小花网络科技（深圳）有限公司',
	              icp: '粤ICP备2021018097号-1'
	          },
	          'www.xinxiloan.com': {
	              company: '重庆信喜小额贷款有限公司',
	              icp: '渝ICP备18006248号-1'
	          },
	          'www.dachengrd.com': {
	              company: '重庆大诚融资担保有限公司',
	              icp: '渝ICP备2021009587号-1'
	          },
	          'www.truechine.com': {
	              company: '上海处成科技有限公司',
	              icp: '沪ICP备2020027929号-2'
	          },
	          'www.truecheng.com': {
	              company: '上海处成科技有限公司',
	              icp: '沪ICP备2020027929号-1'
	          },
	          'www.kanzhonginfo.com': {
	              company: '重庆看重信息科技有限公司',
	              icp: '渝ICP备2021005605号-1'
	          },
	          'www.cqkanzhong.com': {
	              company: '重庆看重信息科技有限公司',
	              icp: '渝ICP备2021005605号-3'
	          },
	          'www.zhuyexiaowei.com': {
	              company: '重庆看重信息科技有限公司',
	              icp: '渝ICP备2021005605号-5'
	          },
	          'www.zhuyexw.com': {
	              company: '重庆看重信息科技有限公司',
	              icp: '渝ICP备2021005605号-4'
	          },
	          'www.xiaohuaai.com': {
	              company: '晓花（上海）互联网科技有限公司',
	              icp: '沪ICP备20014574号-5'
	          },
	          'www.xh0.cn': {
	              company: '晓花（上海）互联网科技有限公司',
	              icp: '沪ICP备20014574号-9'
	          },
	          'www.facash.com': {
	              company: '晓花（上海）互联网科技有限公司',
	              icp: '沪ICP备20014574号-7'
	          },
	          '0.0.0.0': {
	              company: '这是测试用的本地主体',
	              icp: '这是测试用的本地ICP'
	          },
	          '127.0.0.1': {
	              company: '这是测试用的本地主体-1',
	              icp: '这是测试用的本地ICP-1'
	          },
	          localhost: {
	              company: '这是测试用的本地主体-2',
	              icp: '这是测试用的本地ICP-2'
	          },
	          'test.xiaohuaai.com': {
	              company: '这是测试用的本地主体-3',
	              icp: '这是测试用的本地ICP-3'
	          }
	      };
	      var result;
	      if (Object.keys(obj).includes(host)) {
	          result = obj[host];
	      }
	      else {
	          result = {
	              company: '',
	              icp: ''
	          };
	      }
	      return result;
	  }
	
	  /**
	   * 跳转应用商店
	   * 封装 window.location.href
	   * 可选参数appChannel
	   *
	   * appChannel: 渠道（可选）
	   * @param appChannel
	   */
	  function downloadApp(appChannel) {
	      var ua = window.navigator.userAgent.toLowerCase();
	      var match = ua.match(/MicroMessenger/i);
	      if (match === null) {
	          if (isAndroid()) {
	              if (appChannel) {
	                  location.href = "https://dl.xhqb.com/Android/prod/" + appChannel + ".apk";
	                  return;
	              }
	              location.href = "https://dl.xhqbapp.com/Android/prod/xhqb01.apk";
	          }
	          else if (isIos()) {
	              location.href =
	                  'https://apps.apple.com/us/app/%E6%96%B0%E5%B0%8F%E8%8A%B1%E9%92%B1%E5%8C%85/id1580545905';
	          }
	          else {
	              location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.xhqb.app';
	          }
	      }
	      else if (match.includes('micromessenger')) {
	          location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.xhqb.app';
	      }
	  }
	
	  exports.downloadApp = downloadApp;
	  exports.dynamicLoad = dynamicLoad;
	  exports.formatter = index$3;
	  exports.localStore = localStore;
	  exports.modifyICP = modifyICP;
	  exports.rule = rule;
	  exports.sessionStore = sessionStore;
	  exports.url = index$2;
	  exports.useragent = index;
	  exports.validator = index$1;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	// THIS FILE IS GENERATED - DO NOT EDIT!
	/*!mobile-detect v1.4.4 2019-09-21*/
	/*global module:false, define:false*/
	/*jshint latedef:false*/
	/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
	(function (define, undefined) {
	define(function () {
	    'use strict';
	
	    var impl = {};
	
	    impl.mobileDetectRules = {
	    "phones": {
	        "iPhone": "\\biPhone\\b|\\biPod\\b",
	        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+",
	        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
	        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
	        "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
	        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
	        "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F",
	        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)|LM-G710",
	        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
	        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
	        "NokiaLumia": "Lumia [0-9]{3,4}",
	        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
	        "Palm": "PalmSource|Palm",
	        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
	        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
	        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
	        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
	        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
	        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
	        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
	        "Alcatel": "Alcatel",
	        "Nintendo": "Nintendo (3DS|Switch)",
	        "Amoi": "Amoi",
	        "INQ": "INQ",
	        "OnePlus": "ONEPLUS",
	        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
	    },
	    "tablets": {
	        "iPad": "iPad|iPad.*Mobile",
	        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
	        "GoogleTablet": "Android.*Pixel C",
	        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835|SM-T830|SM-T837V|SM-T720|SM-T510|SM-T387V",
	        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
	        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
	        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
	        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
	        "BlackBerryTablet": "PlayBook|RIM Tablet",
	        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
	        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
	        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
	        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
	        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
	        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
	        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
	        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
	        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304X|TB-X304F|TB-X304L|TB-X505F|TB-X505L|TB-X505X|TB-X605F|TB-X605L|TB-8703F|TB-8703X|TB-8703N|TB-8704N|TB-8704F|TB-8704X|TB-8704V|TB-7304F|TB-7304I|TB-7304X|Tab2A7-10F|Tab2A7-20F|TB2-X30L|YT3-X50L|YT3-X50F|YT3-X50M|YT-X705F|YT-X703F|YT-X703L|YT-X705L|YT-X705X|TB2-X30F|TB2-X30L|TB2-X30M|A2107A-F|A2107A-H|TB3-730F|TB3-730M|TB3-730X|TB-7504F|TB-7504X",
	        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
	        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
	        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
	        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
	        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
	        "IRUTablet": "M702pro",
	        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
	        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
	        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
	        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
	        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
	        "NokiaLumiaTablet": "Lumia 2520",
	        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
	        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
	        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
	        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
	        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
	        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
	        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
	        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
	        "FlyTablet": "IQ310|Fly Vision",
	        "bqTablet": "Android.*(bq)?.*\\b(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))\\b|Maxwell.*Lite|Maxwell.*Plus",
	        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09|AGS-L09|CMR-AL19",
	        "NecTablet": "\\bN-06D|\\bN-08D",
	        "PantechTablet": "Pantech.*P4100",
	        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
	        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
	        "ZyncTablet": "z1000|Z99 2G|z930|z990|z909|Z919|z900",
	        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
	        "NabiTablet": "Android.*\\bNabi",
	        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
	        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
	        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
	        "PlaystationTablet": "Playstation.*(Portable|Vita)",
	        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
	        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
	        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
	        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
	        "GalapadTablet": "Android.*\\bG1\\b(?!\\))",
	        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
	        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
	        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
	        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
	        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
	        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
	        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
	        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
	        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
	        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
	        "DPSTablet": "DPS Dream 9|DPS Dual 7",
	        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
	        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
	        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
	        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
	        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
	        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
	        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
	        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
	        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
	        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497|VFD 1400",
	        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
	        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
	        "iMobileTablet": "i-mobile i-note",
	        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
	        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
	        "AMPETablet": "Android.* A78 ",
	        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
	        "TecnoTablet": "TECNO P9|TECNO DP8D",
	        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
	        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
	        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
	        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
	        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
	        "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
	        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
	        "CaptivaTablet": "CAPTIVA PAD",
	        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
	        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
	        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
	        "JaytechTablet": "TPC-PA762",
	        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
	        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
	        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
	        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
	        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
	        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
	        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
	        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
	        "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
	        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
	        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
	        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
	        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
	        "UbislateTablet": "UbiSlate[\\s]?7C",
	        "PocketBookTablet": "Pocketbook",
	        "KocasoTablet": "\\b(TB-1207)\\b",
	        "HisenseTablet": "\\b(F5281|E2371)\\b",
	        "Hudl": "Hudl HT7S3|Hudl 2",
	        "TelstraTablet": "T-Hub2",
	        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
	    },
	    "oss": {
	        "AndroidOS": "Android",
	        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
	        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
	        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
	        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE;",
	        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
	        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
	        "iPadOS": "CPU OS 13",
	        "MeeGoOS": "MeeGo",
	        "MaemoOS": "Maemo",
	        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
	        "webOS": "webOS|hpwOS",
	        "badaOS": "\\bBada\\b",
	        "BREWOS": "BREW"
	    },
	    "uas": {
	        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
	        "Dolfin": "\\bDolfin\\b",
	        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+$|Coast\/[0-9.]+",
	        "Skyfire": "Skyfire",
	        "Edge": "Mobile Safari\/[.0-9]* Edge",
	        "IE": "IEMobile|MSIEMobile",
	        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
	        "Bolt": "bolt",
	        "TeaShark": "teashark",
	        "Blazer": "Blazer",
	        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
	        "WeChat": "\\bMicroMessenger\\b",
	        "UCBrowser": "UC.*Browser|UCWEB",
	        "baiduboxapp": "baiduboxapp",
	        "baidubrowser": "baidubrowser",
	        "DiigoBrowser": "DiigoBrowser",
	        "Mercury": "\\bMercury\\b",
	        "ObigoBrowser": "Obigo",
	        "NetFront": "NF-Browser",
	        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
	        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
	    },
	    "props": {
	        "Mobile": "Mobile\/[VER]",
	        "Build": "Build\/[VER]",
	        "Version": "Version\/[VER]",
	        "VendorID": "VendorID\/[VER]",
	        "iPad": "iPad.*CPU[a-z ]+[VER]",
	        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
	        "iPod": "iPod.*CPU[a-z ]+[VER]",
	        "Kindle": "Kindle\/[VER]",
	        "Chrome": [
	            "Chrome\/[VER]",
	            "CriOS\/[VER]",
	            "CrMo\/[VER]"
	        ],
	        "Coast": [
	            "Coast\/[VER]"
	        ],
	        "Dolfin": "Dolfin\/[VER]",
	        "Firefox": [
	            "Firefox\/[VER]",
	            "FxiOS\/[VER]"
	        ],
	        "Fennec": "Fennec\/[VER]",
	        "Edge": "Edge\/[VER]",
	        "IE": [
	            "IEMobile\/[VER];",
	            "IEMobile [VER]",
	            "MSIE [VER];",
	            "Trident\/[0-9.]+;.*rv:[VER]"
	        ],
	        "NetFront": "NetFront\/[VER]",
	        "NokiaBrowser": "NokiaBrowser\/[VER]",
	        "Opera": [
	            " OPR\/[VER]",
	            "Opera Mini\/[VER]",
	            "Version\/[VER]"
	        ],
	        "Opera Mini": "Opera Mini\/[VER]",
	        "Opera Mobi": "Version\/[VER]",
	        "UCBrowser": [
	            "UCWEB[VER]",
	            "UC.*Browser\/[VER]"
	        ],
	        "MQQBrowser": "MQQBrowser\/[VER]",
	        "MicroMessenger": "MicroMessenger\/[VER]",
	        "baiduboxapp": "baiduboxapp\/[VER]",
	        "baidubrowser": "baidubrowser\/[VER]",
	        "SamsungBrowser": "SamsungBrowser\/[VER]",
	        "Iron": "Iron\/[VER]",
	        "Safari": [
	            "Version\/[VER]",
	            "Safari\/[VER]"
	        ],
	        "Skyfire": "Skyfire\/[VER]",
	        "Tizen": "Tizen\/[VER]",
	        "Webkit": "webkit[ \/][VER]",
	        "PaleMoon": "PaleMoon\/[VER]",
	        "Gecko": "Gecko\/[VER]",
	        "Trident": "Trident\/[VER]",
	        "Presto": "Presto\/[VER]",
	        "Goanna": "Goanna\/[VER]",
	        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
	        "Android": "Android [VER]",
	        "BlackBerry": [
	            "BlackBerry[\\w]+\/[VER]",
	            "BlackBerry.*Version\/[VER]",
	            "Version\/[VER]"
	        ],
	        "BREW": "BREW [VER]",
	        "Java": "Java\/[VER]",
	        "Windows Phone OS": [
	            "Windows Phone OS [VER]",
	            "Windows Phone [VER]"
	        ],
	        "Windows Phone": "Windows Phone [VER]",
	        "Windows CE": "Windows CE\/[VER]",
	        "Windows NT": "Windows NT [VER]",
	        "Symbian": [
	            "SymbianOS\/[VER]",
	            "Symbian\/[VER]"
	        ],
	        "webOS": [
	            "webOS\/[VER]",
	            "hpwOS\/[VER];"
	        ]
	    },
	    "utils": {
	        "Bot": "Googlebot|facebookexternalhit|Google-AMPHTML|s~amp-validator|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom|contentkingapp",
	        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
	        "DesktopMode": "WPDesktop",
	        "TV": "SonyDTV|HbbTV",
	        "WebKit": "(webkit)[ \/]([\\w.]+)",
	        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
	        "Watch": "SM-V700"
	    }
	};
	
	    // following patterns come from http://detectmobilebrowsers.com/
	    impl.detectMobileBrowsers = {
	        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
	        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
	        tabletPattern: /android|ipad|playbook|silk/i
	    };
	
	    var hasOwnProp = Object.prototype.hasOwnProperty,
	        isArray;
	
	    impl.FALLBACK_PHONE = 'UnknownPhone';
	    impl.FALLBACK_TABLET = 'UnknownTablet';
	    impl.FALLBACK_MOBILE = 'UnknownMobile';
	
	    isArray = ('isArray' in Array) ?
	        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };
	
	    function equalIC(a, b) {
	        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
	    }
	
	    function containsIC(array, value) {
	        var valueLC, i, len = array.length;
	        if (!len || !value) {
	            return false;
	        }
	        valueLC = value.toLowerCase();
	        for (i = 0; i < len; ++i) {
	            if (valueLC === array[i].toLowerCase()) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function convertPropsToRegExp(object) {
	        for (var key in object) {
	            if (hasOwnProp.call(object, key)) {
	                object[key] = new RegExp(object[key], 'i');
	            }
	        }
	    }
	
	    function prepareUserAgent(userAgent) {
	        return (userAgent || '').substr(0, 500); // mitigate vulnerable to ReDoS
	    }
	
	    (function init() {
	        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
	        for (key in mobileDetectRules.props) {
	            if (hasOwnProp.call(mobileDetectRules.props, key)) {
	                values = mobileDetectRules.props[key];
	                if (!isArray(values)) {
	                    values = [values];
	                }
	                len = values.length;
	                for (i = 0; i < len; ++i) {
	                    value = values[i];
	                    verPos = value.indexOf('[VER]');
	                    if (verPos >= 0) {
	                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
	                    }
	                    values[i] = new RegExp(value, 'i');
	                }
	                mobileDetectRules.props[key] = values;
	            }
	        }
	        convertPropsToRegExp(mobileDetectRules.oss);
	        convertPropsToRegExp(mobileDetectRules.phones);
	        convertPropsToRegExp(mobileDetectRules.tablets);
	        convertPropsToRegExp(mobileDetectRules.uas);
	        convertPropsToRegExp(mobileDetectRules.utils);
	
	        // copy some patterns to oss0 which are tested first (see issue#15)
	        mobileDetectRules.oss0 = {
	            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
	            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
	        };
	    }());
	
	    /**
	     * Test userAgent string against a set of rules and find the first matched key.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
	     * @private
	     */
	    impl.findMatch = function(rules, userAgent) {
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    return key;
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Test userAgent string against a set of rules and return an array of matched keys.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
	     * @private
	     */
	    impl.findMatches = function(rules, userAgent) {
	        var result = [];
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    result.push(key);
	                }
	            }
	        }
	        return result;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {String} version or <tt>null</tt> if version not found
	     * @private
	     */
	    impl.getVersionStr = function (propertyName, userAgent) {
	        var props = impl.mobileDetectRules.props, patterns, i, len, match;
	        if (hasOwnProp.call(props, propertyName)) {
	            patterns = props[propertyName];
	            len = patterns.length;
	            for (i = 0; i < len; ++i) {
	                match = patterns[i].exec(userAgent);
	                if (match !== null) {
	                    return match[1];
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {Number} version or <tt>NaN</tt> if version not found
	     * @private
	     */
	    impl.getVersion = function (propertyName, userAgent) {
	        var version = impl.getVersionStr(propertyName, userAgent);
	        return version ? impl.prepareVersionNo(version) : NaN;
	    };
	
	    /**
	     * Prepare the version number.
	     *
	     * @param {String} version
	     * @return {Number} the version number as a floating number
	     * @private
	     */
	    impl.prepareVersionNo = function (version) {
	        var numbers;
	
	        numbers = version.split(/[a-z._ \/\-]/i);
	        if (numbers.length === 1) {
	            version = numbers[0];
	        }
	        if (numbers.length > 1) {
	            version = numbers[0] + '.';
	            numbers.shift();
	            version += numbers.join('');
	        }
	        return Number(version);
	    };
	
	    impl.isMobileFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
	            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
	    };
	
	    impl.isTabletFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
	    };
	
	    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
	        if (cache.mobile !== undefined) {
	            return;
	        }
	        var phone, tablet, phoneSized;
	
	        // first check for stronger tablet rules, then phone (see issue#5)
	        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
	        if (tablet) {
	            cache.mobile = cache.tablet = tablet;
	            cache.phone = null;
	            return; // unambiguously identified as tablet
	        }
	
	        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
	        if (phone) {
	            cache.mobile = cache.phone = phone;
	            cache.tablet = null;
	            return; // unambiguously identified as phone
	        }
	
	        // our rules haven't found a match -> try more general fallback rules
	        if (impl.isMobileFallback(userAgent)) {
	            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
	            if (phoneSized === undefined) {
	                cache.mobile = impl.FALLBACK_MOBILE;
	                cache.tablet = cache.phone = null;
	            } else if (phoneSized) {
	                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
	                cache.tablet = null;
	            } else {
	                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	                cache.phone = null;
	            }
	        } else if (impl.isTabletFallback(userAgent)) {
	            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	            cache.phone = null;
	        } else {
	            // not mobile at all!
	            cache.mobile = cache.tablet = cache.phone = null;
	        }
	    };
	
	    // t is a reference to a MobileDetect instance
	    impl.mobileGrade = function (t) {
	        // impl note:
	        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
	        // When changes are made in Mobile_Detect.php, copy this method and replace:
	        //     $this-> / t.
	        //     self::MOBILE_GRADE_(.) / '$1'
	        //     , self::VERSION_TYPE_FLOAT / (nothing)
	        //     isIOS() / os('iOS')
	        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
	        var $isMobile = t.mobile() !== null;
	
	        if (
	            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
	            t.os('iOS') && t.version('iPad')>=4.3 ||
	            t.os('iOS') && t.version('iPhone')>=3.1 ||
	            t.os('iOS') && t.version('iPod')>=3.1 ||
	
	            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
	            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
	            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
	            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
	            ( t.version('Android')>2.1 && t.is('Webkit') ) ||
	
	            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
	            t.version('Windows Phone OS')>=7.0 ||
	
	            // Blackberry 7 - Tested on BlackBerry Torch 9810
	            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
	            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
	            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
	            t.match('Playbook.*Tablet') ||
	
	            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
	            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
	            // Palm WebOS 3.0  - Tested on HP TouchPad
	            t.match('hp.*TouchPad') ||
	
	            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
	            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||
	
	            // Chrome for Android - Tested on Android 4.0, 4.1 device
	            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||
	
	            // Skyfire 4.1 - Tested on Android 2.3 device
	            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||
	
	            // Opera Mobile 11.5-12: Tested on Android 2.3
	            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||
	
	            // Meego 1.2 - Tested on Nokia 950 and N9
	            t.is('MeeGoOS') ||
	
	            // Tizen (pre-release) - Tested on early hardware
	            t.is('Tizen') ||
	
	            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
	            // @todo: more tests here!
	            t.is('Dolfin') && t.version('Bada')>=2.0 ||
	
	            // UC Browser - Tested on Android 2.3 device
	            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||
	
	            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
	            ( t.match('Kindle Fire') ||
	                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||
	
	            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
	            t.is('AndroidOS') && t.is('NookTablet') ||
	
	            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
	            t.version('Chrome')>=11 && !$isMobile ||
	
	            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
	            t.version('Safari')>=5.0 && !$isMobile ||
	
	            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
	            t.version('Firefox')>=4.0 && !$isMobile ||
	
	            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
	            t.version('MSIE')>=7.0 && !$isMobile ||
	
	            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
	            // @reference: http://my.opera.com/community/openweb/idopera/
	            t.version('Opera')>=10 && !$isMobile
	
	            ){
	            return 'A';
	        }
	
	        if (
	            t.os('iOS') && t.version('iPad')<4.3 ||
	            t.os('iOS') && t.version('iPhone')<3.1 ||
	            t.os('iOS') && t.version('iPod')<3.1 ||
	
	            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
	            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||
	
	            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
	            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
	                (t.version('Android')>=2.3 || t.is('iOS')) ) ||
	
	            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
	            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||
	
	            // @todo: report this (tested on Nokia N71)
	            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
	            ){
	            return 'B';
	        }
	
	        if (
	        // Blackberry 4.x - Tested on the Curve 8330
	            t.version('BlackBerry')<5.0 ||
	            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
	            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2
	
	            ){
	            return 'C';
	        }
	
	        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
	        //will receive the basic, C grade experience.
	        return 'C';
	    };
	
	    impl.detectOS = function (ua) {
	        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
	            impl.findMatch(impl.mobileDetectRules.oss, ua);
	    };
	
	    impl.getDeviceSmallerSide = function () {
	        return window.screen.width < window.screen.height ?
	            window.screen.width :
	            window.screen.height;
	    };
	
	    /**
	     * Constructor for MobileDetect object.
	     * <br>
	     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
	     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
	     *     <strong>Find information how to download and install:</strong>
	     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
	     * </div>
	     *
	     * @example <pre>
	     *     var md = new MobileDetect(window.navigator.userAgent);
	     *     if (md.mobile()) {
	     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
	     *     }
	     * </pre>
	     *
	     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
	     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
	     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
	     *        as phone.
	     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
	     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
	     *        for Android</a>.<br>
	     *        If you provide a value < 0, then this "fuzzy" check is disabled.
	     * @constructor
	     * @global
	     */
	    function MobileDetect(userAgent, maxPhoneWidth) {
	        this.ua = prepareUserAgent(userAgent);
	        this._cache = {};
	        //600dp is typical 7" tablet minimum width
	        this.maxPhoneWidth = maxPhoneWidth || 600;
	    }
	
	    MobileDetect.prototype = {
	        constructor: MobileDetect,
	
	        /**
	         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
	         * <br>
	         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
	         * <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
	         * @function MobileDetect#mobile
	         */
	        mobile: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.mobile;
	        },
	
	        /**
	         * Returns the detected phone type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
	         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
	         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, OnePlus, GenericPhone</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
	         * @function MobileDetect#phone
	         */
	        phone: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.phone;
	        },
	
	        /**
	         * Returns the detected tablet type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
	         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
	         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
	         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
	         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
	         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
	         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
	         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
	         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
	         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
	         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
	         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
	         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
	         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
	         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
	         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
	         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
	         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
	         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
	         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
	         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
	         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
	         * GenericTablet</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
	         * @function MobileDetect#tablet
	         */
	        tablet: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.tablet;
	        },
	
	        /**
	         * Returns the (first) detected user-agent string or <tt>null</tt>.
	         * <br>
	         * The returned user-agent is one of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {String} the key for the detected user-agent or <tt>null</tt>
	         * @function MobileDetect#userAgent
	         */
	        userAgent: function () {
	            if (this._cache.userAgent === undefined) {
	                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgent;
	        },
	
	        /**
	         * Returns all detected user-agent strings.
	         * <br>
	         * The array is empty or contains one or more of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
	         * @function MobileDetect#userAgents
	         */
	        userAgents: function () {
	            if (this._cache.userAgents === undefined) {
	                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgents;
	        },
	
	        /**
	         * Returns the detected operating system string or <tt>null</tt>.
	         * <br>
	         * The operating system is one of following keys:<br>
	         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
	         * iOS, iPadOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
	         *
	         * @returns {String} the key for the detected operating system.
	         * @function MobileDetect#os
	         */
	        os: function () {
	            if (this._cache.os === undefined) {
	                this._cache.os = impl.detectOS(this.ua);
	            }
	            return this._cache.os;
	        },
	
	        /**
	         * Get the version (as Number) of the given property in the User-Agent.
	         * <br>
	         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
	         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
	         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
	         *
	         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
	         *          Be careful when comparing this value with '==' operator!
	         * @function MobileDetect#version
	         */
	        version: function (key) {
	            return impl.getVersion(key, this.ua);
	        },
	
	        /**
	         * Get the version (as String) of the given property in the User-Agent.
	         * <br>
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
	         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
	         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
	         *
	         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
	         *
	         * @function MobileDetect#versionStr
	         */
	        versionStr: function (key) {
	            return impl.getVersionStr(key, this.ua);
	        },
	
	        /**
	         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
	         *
	         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
	         *        tablet family.<br>
	         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
	         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
	         *        Additionally you have following keys:<br>
	         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
	         *
	         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
	         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
	         * @function MobileDetect#is
	         */
	        is: function (key) {
	            return containsIC(this.userAgents(), key) ||
	                   equalIC(key, this.os()) ||
	                   equalIC(key, this.phone()) ||
	                   equalIC(key, this.tablet()) ||
	                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
	        },
	
	        /**
	         * Do a quick test against navigator::userAgent.
	         *
	         * @param {String|RegExp} pattern the pattern, either as String or RegExp
	         *                        (a string will be converted to a case-insensitive RegExp).
	         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
	         * @function MobileDetect#match
	         */
	        match: function (pattern) {
	            if (!(pattern instanceof RegExp)) {
	                pattern = new RegExp(pattern, 'i');
	            }
	            return pattern.test(this.ua);
	        },
	
	        /**
	         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
	         * <br>
	         * Obviously this method makes sense in browser environments only (not for Node.js)!
	         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
	         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
	         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
	         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
	         *          Will always return <code>undefined</code> server-side.
	         */
	        isPhoneSized: function (maxPhoneWidth) {
	            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
	        },
	
	        /**
	         * Returns the mobile grade ('A', 'B', 'C').
	         *
	         * @returns {String} one of the mobile grades ('A', 'B', 'C').
	         * @function MobileDetect#mobileGrade
	         */
	        mobileGrade: function () {
	            if (this._cache.grade === undefined) {
	                this._cache.grade = impl.mobileGrade(this);
	            }
	            return this._cache.grade;
	        }
	    };
	
	    // environment-dependent
	    if (typeof window !== 'undefined' && window.screen) {
	        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
	            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
	        };
	    } else {
	        MobileDetect.isPhoneSized = function () {};
	    }
	
	    // should not be replaced by a completely new object - just overwrite existing methods
	    MobileDetect._impl = impl;
	    
	    MobileDetect.version = '1.4.4 2019-09-21';
	
	    return MobileDetect;
	}); // end of call of define()
	})((function (undefined) {
	    if (typeof module !== 'undefined' && module.exports) {
	        return function (factory) { module.exports = factory(); };
	    } else if (true) {
	        return __webpack_require__(103);
	    } else if (typeof window !== 'undefined') {
	        return function (factory) { window.MobileDetect = factory(); };
	    } else {
	        // please file a bug if you get this error!
	        throw new Error('unknown environment');
	    }
	})());

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(106), __esModule: true };

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(77);
	__webpack_require__(16);
	__webpack_require__(60);
	__webpack_require__(107);
	__webpack_require__(125);
	__webpack_require__(126);
	module.exports = __webpack_require__(24).Promise;


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(21);
	var global = __webpack_require__(23);
	var ctx = __webpack_require__(25);
	var classof = __webpack_require__(108);
	var $export = __webpack_require__(22);
	var isObject = __webpack_require__(30);
	var aFunction = __webpack_require__(26);
	var anInstance = __webpack_require__(109);
	var forOf = __webpack_require__(110);
	var speciesConstructor = __webpack_require__(114);
	var task = __webpack_require__(115).set;
	var microtask = __webpack_require__(117)();
	var newPromiseCapabilityModule = __webpack_require__(118);
	var perform = __webpack_require__(119);
	var userAgent = __webpack_require__(120);
	var promiseResolve = __webpack_require__(121);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(57)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(122)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(56)($Promise, PROMISE);
	__webpack_require__(123)(PROMISE);
	Wrapper = __webpack_require__(24)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(124)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(47);
	var TAG = __webpack_require__(57)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(25);
	var call = __webpack_require__(111);
	var isArrayIter = __webpack_require__(112);
	var anObject = __webpack_require__(29);
	var toLength = __webpack_require__(49);
	var getIterFn = __webpack_require__(113);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(29);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(39);
	var ITERATOR = __webpack_require__(57)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(108);
	var ITERATOR = __webpack_require__(57)('iterator');
	var Iterators = __webpack_require__(39);
	module.exports = __webpack_require__(24).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(29);
	var aFunction = __webpack_require__(26);
	var SPECIES = __webpack_require__(57)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(25);
	var invoke = __webpack_require__(116);
	var html = __webpack_require__(55);
	var cel = __webpack_require__(34);
	var global = __webpack_require__(23);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(47)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),

/***/ 116:
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(23);
	var macrotask = __webpack_require__(115).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(47)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(26);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),

/***/ 119:
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(23);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(29);
	var isObject = __webpack_require__(30);
	var newPromiseCapability = __webpack_require__(118);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(27);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(23);
	var core = __webpack_require__(24);
	var dP = __webpack_require__(28);
	var DESCRIPTORS = __webpack_require__(32);
	var SPECIES = __webpack_require__(57)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(57)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(22);
	var core = __webpack_require__(24);
	var global = __webpack_require__(23);
	var speciesConstructor = __webpack_require__(114);
	var promiseResolve = __webpack_require__(121);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(22);
	var newPromiseCapability = __webpack_require__(118);
	var perform = __webpack_require__(119);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),

/***/ 128:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(99);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(105);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jwe = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by dongruihe on 2017/3/13.
	 */
	var util = __webpack_require__(94);
	// import { useragent } from "@xhtech/lux";
	// import interceptor from '../interceptors';
	// interceptor();
	
	Vue.use(__webpack_require__(3));
	var ajax = module.exports;
	var base = ("");
	
	console.log('base1:', base);
	var isPrd = ("production") === 'uat' || ("production") === 'production';
	// const isPrd = true
	
	//base = 'http://10.3.208.85:8080'
	function ajaxFail(vm, response, error) {
	    // 关闭loading
	    if (response.status === 403) {
	        var href = window.location.href;
	        var loginTem = '';
	        var url = '';
	        if (href.indexOf('share/lead.html') >= 0 || href.indexOf('lottery') >= 0) {
	            //loginTem = 'share';
	            //url ="/h5/login?view="+loginTem+"&redirect=";
	            vm.isLogin = false;
	            util.closeLoading();
	            return;
	        } else {
	            loginTem = 'changecard';
	            var isH5ProApi = response.url.indexOf('/h5pro-api/') > -1;
	            var isCouponApi = response.url.indexOf('/h5api/couponapi') > -1;
	            var isMarketApi = response.url.indexOf('/h5api/marketapi') > -1;
	            // const loginUrl = encodeURIComponent(window.location.origin + '/client/login.html')
	            var redirect = encodeURIComponent(window.location.href);
	            console.log('util.isAddGw()', util.isAddGw());
	            if (isH5ProApi) {
	                if (util.isAddGw()) {
	                    url = '/gw/h5pro-api/login?view=apply_p&redirect=' + redirect + '&appChannel=&isGateway=true';
	                } else {
	                    url = '/h5pro-api/login?view=apply_p&redirect=' + redirect + '&appChannel=';
	                }
	            } else if (isCouponApi || isMarketApi) {
	                if (util.isAddGw()) {
	                    url = '/gw/h5api/login?view=' + loginTem + '&redirect=' + redirect + '&isGateway=true';
	                } else {
	                    url = '/h5api/login?view=' + loginTem + '&redirect=' + redirect;
	                }
	            } else {
	                if (util.isAddGw()) {
	                    url = '/gw/h5-loan/h5login?view=' + loginTem + '&redirect=' + redirect + '&isGateway=true';
	                } else {
	                    url = '/h5-loan/h5login?view=' + loginTem + '&redirect=' + redirect;
	                }
	            }
	        }
	        // url += encodeURIComponent(href);
	        window.location.href = '' + base + url;
	        return;
	    } else if (response.status === 404) {
	        util.closeLoading();
	        vm.failureState = {
	            show: true
	        };
	    } else {
	        util.closeLoading();
	    }
	    //响应错误响应
	    if (typeof error == 'function' && error != null) {
	        util.closeLoading();
	        error(response);
	        vm.failureState = {
	            show: true
	        };
	    }
	}
	
	ajax.get = function (vm, url, params, success, error) {
	    if (!params.hideLoading) {
	        util.showLoading();
	    }
	    var newUrl = base + url;
	    if (util.isAddGw()) {
	        newUrl = base + '/gw' + url;
	    }
	
	    Vue.http.get(newUrl, params).then(function (response) {
	        // 关闭loading
	        util.closeLoading();
	        //响应正确响应
	        if (typeof success == 'function' && success != null) {
	            try {
	                success(JSON.parse(response.body));
	            } catch (error) {
	                console.error('请求响应格式错误：' + error + response);
	            }
	        }
	    }, function (response) {
	        ajaxFail(vm, response, error);
	    });
	};
	
	ajax.post = function (vm, url, params, success, error) {
	    if (!params.hideLoading) {
	        util.showLoading();
	    }
	    var newUrl = base + url;
	    if (util.isAddGw()) {
	        newUrl = base + '/gw' + url;
	    }
	
	    Vue.http.post(newUrl, params).then(function (response) {
	        // 关闭loading
	        util.closeLoading();
	        //响应正确响应
	        if (typeof success == 'function' && success != null) {
	            try {
	                //   success(JSON.parse(response.body));
	                if (response.data && typeof response.data == "string" && isPrd) {
	                    (0, _jwe.decrypter)(response.data).then(function (decryptData) {
	                        if (decryptData.result) {
	                            response.data = JSON.parse(decryptData.data);
	                            success(response.data);
	                            return;
	                        }
	                        response.body = JSON.parse(response.body);
	                        success(response.body);
	                    });
	                } else {
	                    success(JSON.parse(response.body));
	                }
	            } catch (error) {
	                console.error('请求响应格式错误：' + error + response);
	            }
	        }
	    }, function (response) {
	        if (response.data && typeof response.data == "string" && isPrd) {
	            (0, _jwe.decrypter)(response.data).then(function (decryptData) {
	                if (decryptData.result) {
	                    response.data = JSON.parse(decryptData.data);
	                    ajaxFail(vm, response, error);
	                    return;
	                }
	                response.data = JSON.parse(response.data);
	                ajaxFail(vm, response, error);
	            });
	        } else {
	            ajaxFail(vm, response, error);
	        }
	    });
	};
	ajax.toPost = function (obj) {
	    /*vm,url,params,headers,success,error*/
	    util.showLoading();
	    var vuegetsend = obj.headers ? { headers: obj.headers } : {};
	
	    var newUrl = base + obj.url;
	
	    if (util.isAddGw()) {
	        newUrl = base + '/gw' + obj.url;
	    }
	
	    Vue.http.post(newUrl, obj.params, vuegetsend).then(function (response) {
	        // 关闭loading
	        util.closeLoading();
	        //响应正确响应
	        if (typeof obj.success == 'function' && obj.success != null) {
	            // if(response.data){
	            //     response.data=typeof(response.data)=="string" ? JSON.parse(response.data) : response.data;
	            // }
	            // obj.success(response);
	            if (response.data && typeof response.data == "string" && isPrd) {
	                (0, _jwe.decrypter)(response.data).then(function (decryptData) {
	                    if (decryptData.result) {
	                        response.data = JSON.parse(decryptData.data);
	                        obj.success(response);
	                        return;
	                    }
	                    response.data = JSON.parse(response.data);
	                    obj.success(response);
	                });
	            } else {
	                obj.success(response);
	            }
	        }
	    }, function (response) {
	        // if(response.data){
	        //     response.data=typeof(response.data)=="string" ? JSON.parse(response.data) : response.data;
	        // }
	        // ajaxFail(obj.vm,response,obj.error);
	        if (response.data && typeof response.data == "string" && isPrd) {
	            (0, _jwe.decrypter)(response.data).then(function (decryptData) {
	                if (decryptData.result) {
	                    response.data = JSON.parse(decryptData.data);
	                    ajaxFail(obj.vm, response, obj.error);
	                    return;
	                }
	                response.data = JSON.parse(response.data);
	                ajaxFail(obj.vm, response, obj.error);
	            });
	        } else {
	            ajaxFail(obj.vm, response, obj.error);
	        }
	    });
	};
	
	ajax.newPost = function (obj) {
	    /*vm,url,params,headers,success,error*/
	    util.showLoading();
	    var vuegetsend = obj.headers ? { headers: obj.headers } : {};
	    var newUrl = base + obj.url;
	    if (util.isAddGw()) {
	        newUrl = base + '/gw' + obj.url;
	    }
	
	    Vue.http.post(newUrl, obj.params, vuegetsend).then(function (response) {
	        // 关闭loading
	        util.closeLoading();
	        //响应正确响应
	        if (typeof obj.success == 'function' && obj.success != null) {
	            if (response.data && typeof response.data == "string" && isPrd) {
	                (0, _jwe.decrypter)(response.data).then(function (decryptData) {
	                    if (decryptData.result) {
	                        response.data = JSON.parse(decryptData.data);
	                        obj.success(response);
	                        return;
	                    }
	                    response.data = JSON.parse(response.data);
	                    obj.success(response);
	                });
	            } else {
	                obj.success(response);
	            }
	        }
	    }, function (response) {
	        if (response.data && typeof response.data == "string" && isPrd) {
	            (0, _jwe.decrypter)(response.data).then(function (decryptData) {
	                if (decryptData.result) {
	                    response.data = JSON.parse(decryptData.data);
	                    obj.error(response);
	                    return;
	                }
	                response.data = JSON.parse(response.data);
	                obj.error(response);
	            });
	        } else {
	            obj.error(response);
	        }
	    });
	};
	
	ajax.postPromise = function (url, params) {
	    util.showLoading();
	    return new _promise2.default(function (resolve, reject) {
	        var newUrl = base + url;
	        if (util.isAddGw()) {
	            newUrl = base + '/gw' + url;
	        }
	
	        Vue.http.post(newUrl, params).then(function (response) {
	            // 关闭loading
	            util.closeLoading();
	            //响应正确响应
	            if (typeof obj.success == 'function' && obj.success != null) {
	                if (response.data && typeof response.data == "string" && isPrd) {
	                    (0, _jwe.decrypter)(response.data).then(function (decryptData) {
	                        if (decryptData.result) {
	                            response.data = JSON.parse(decryptData.data);
	                            resolve(response);
	                            return;
	                        }
	                        response.data = JSON.parse(response.data);
	                        resolve(response);
	                    });
	                } else {
	                    resolve(response);
	                }
	            }
	        }, function (response) {
	            if (response.data && typeof response.data == "string" && isPrd) {
	                (0, _jwe.decrypter)(response.data).then(function (decryptData) {
	                    if (decryptData.result) {
	                        response.data = JSON.parse(decryptData.data);
	                        reject(response);
	                        return;
	                    }
	                    response.data = reject(response.data);
	                    reject(response);
	                });
	            } else {
	                reject(response);
	            }
	        });
	    });
	};
	
	Vue.http.interceptors.push(function (request, next) {
	    var newApi = util.isAddGw() ? request.url.split('/')[2] : request.url.split('/')[1];
	    if (request.method == 'post' &&
	    // request.body && 
	    request.url.indexOf('/xwd-api/') === -1 && request.url.indexOf('/auth/') === -1 && request.url.indexOf('/gondarfront-in/') === -1 && request.url.indexOf('/weixinh5/') === -1 &&
	    // Object.keys(request.body).length > 0 && 
	    isPrd) {
	        (0, _jwe.encrypter)({
	            kid: newApi || '',
	            plaintext: (0, _stringify2.default)(request.body)
	        }).then(function (encryptData) {
	            if (encryptData.result) {
	                request.body = encryptData.data;
	                request.headers['jose'] = 'Y';
	                request.headers['Content-Type'] = 'application/json';
	            }
	            next(function (response) {
	                //   if (response.data && typeof response.data == "string") {
	                //     decrypter(response.data).then(function(decryptData){
	                //       if(decryptData.result){
	                //         response.body = decryptData.data;
	                //         return response
	                //       }
	                //       return response
	                //     })
	                //   }else{
	                //     return response;
	                //   }
	                return response;
	            });
	        });
	    } else {
	        next(function (response) {
	            return response;
	        });
	    }
	});

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(105);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.encrypter = encrypter;
	exports.decrypter = decrypter;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cryptographer = new Jose.WebCryptographer();
	
	function encrypter(opts) {
	  return new _promise2.default(function (resolve) {
	    var publicRsaKey = {
	      // n = modulus
	      n: '00:B7:84:96:95:A2:86:78:7F:C6:8F:0B:1E:C2:C6:5C:DC:78:37:3D:0B:B3:8B:6C:DB:88:29:1C:AC:0E:96:96:4E:A9:8B:20:AA:66:28:AB:AB:9C:64:2A:F4:B9:DF:12:18:CE:DF:A0:8B:5A:60:C8:0A:FB:37:B6:CF:95:F6:39:AF:F7:97:D9:87:EE:67:D6:C4:F4:1E:7D:A8:F3:90:84:47:FB:4B:14:38:93:2F:65:BC:C8:43:DF:27:72:97:5D:EA:7A:BC:34:76:80:F2:92:8A:C0:A0:E5:31:4A:AD:8B:13:6E:35:81:2E:78:20:41:AD:7D:D1:37:63:67:FB:09:97:52:9F:1D:69:1A:F4:C9:33:10:A5:95:D1:02:78:38:F5:24:C6:AA:71:6C:CF:3C:DF:9E:B0:72:22:3E:C1:2F:5E:92:B5:75:DA:4C:4D:86:2F:55:3D:D5:4D:22:C8:DE:D0:22:1F:1D:D4:95:FC:1E:97:4A:B3:63:A0:24:E1:22:4C:D3:0B:B4:33:C8:E0:14:89:64:46:F9:27:55:D6:E4:8D:55:EE:22:06:50:C1:46:AF:18:5C:79:14:FA:7B:97:31:11:14:75:41:82:EC:FC:96:AB:24:65:6F:99:15:60:58:A2:76:AB:68:81:1A:D7:38:FF:9C:9E:B2:F5:A2:17:65',
	      // e = publicExponent
	      e: 65537
	    };
	    var public_rsa_key = Jose.Utils.importRsaPublicKey(publicRsaKey, "RSA-OAEP");
	    var encrypter = new Jose.JoseJWE.Encrypter(cryptographer, public_rsa_key);
	    encrypter.addHeader('kid', opts.kid);
	    encrypter.encrypt(opts.plaintext).then(function (res) {
	      resolve({ result: true, data: res });
	    }).catch(function (err) {
	      resolve({ result: false, data: err });
	    });
	  });
	}
	
	function decrypter(ciphertext) {
	  return new _promise2.default(function (resolve) {
	    var privateRsaKey = {
	      // n = modulus
	      n: '00:d3:b8:5e:dd:71:4e:79:22:6c:c5:6b:11:a6:f1:b1:be:58:9f:88:56:8f:26:62:08:4f:de:15:b8:53:60:ab:f3:a7:a7:a4:a7:25:73:39:f2:0b:c0:0d:92:dd:ce:59:b6:ce:f8:4c:c4:f1:bf:72:54:6f:6a:8c:04:f0:08:aa:d0:5f:59:6d:3f:fe:48:d8:fc:41:ed:af:7c:9c:d0:24:01:ca:31:ae:91:8b:42:bd:c9:00:fa:d8:da:e6:e9:d4:ba:a0:f0:d2:8f:70:26:b2:05:a2:79:27:0d:37:8b:7d:5c:e7:18:10:d7:16:f7:9f:07:55:ec:39:5b:33:cd:88:51:c1:4b:a6:1f:7a:dd:a9:6f:63:50:65:d1:df:d1:72:72:b1:37:a8:63:90:31:66:05:ae:93:a5:a3:a7:c8:72:85:99:e5:44:1c:bb:5e:d5:d5:ce:a6:98:42:2b:9b:73:b8:3d:c6:d0:bf:c8:e8:ca:d7:84:38:16:a7:c5:a6:54:e4:87:d0:a3:22:af:22:70:99:ab:81:e3:d7:26:fd:07:c2:f2:72:56:ed:19:7a:84:6d:bd:dc:28:3a:c9:2a:fc:86:5e:30:29:a2:15:59:70:3a:42:3d:cd:44:23:c2:fe:15:fb:15:b0:1f:bc:ab:a8:d1:49:c2:24:83:f1:f9:8b:4f',
	      // e = publicExponent
	      e: 65537,
	      // d = privateExponent
	      d: '20:58:1e:45:fe:35:5a:d4:23:81:d5:65:90:f7:83:8b:ec:c6:12:72:06:d4:7a:4d:82:c6:0e:d3:66:09:72:bb:7a:75:65:f6:13:06:93:67:a2:db:e8:36:f3:a3:be:98:ea:ed:8b:ec:da:71:c0:e9:9d:4b:cd:b0:43:6b:4f:8d:1d:c3:ef:a8:c3:14:25:f2:03:b0:68:0a:c5:7a:16:c6:1f:39:8f:cd:b4:54:b1:e1:af:40:a3:38:6d:e6:73:15:3f:d9:0a:91:d7:34:52:26:02:38:37:fb:10:ed:42:6d:9a:f0:56:42:45:c3:f6:8b:8c:58:d6:3a:54:a3:a5:9b:70:9c:a6:48:dd:be:9c:f0:cc:59:dd:95:7d:27:b4:21:04:d2:be:3f:a2:ed:5c:02:bf:4d:d1:30:97:70:71:f1:03:79:34:8e:0e:d1:ff:5c:1a:78:c6:08:99:5b:bc:1f:db:ce:e9:69:e8:01:96:66:40:aa:b5:9a:6f:e7:32:6d:11:63:7f:03:23:ca:38:4b:98:7e:59:1a:29:db:cf:9f:c3:da:8c:b3:b1:7d:64:fd:7f:3a:96:f2:11:91:41:1d:e3:93:93:79:78:6e:db:28:02:e9:2c:f1:e4:d1:cc:23:4f:09:13:da:4d:d9:72:96:71:d1:09:48:52:11:91:e1',
	      // p = prime1
	      p: '00:f0:72:cf:29:7f:34:df:73:36:3e:a7:5d:8d:1e:09:04:91:18:05:fe:aa:06:b8:1f:2d:dd:a4:b2:ba:9c:36:2d:ae:2e:b7:49:50:82:b2:2c:6c:6e:d1:b5:31:41:be:ef:63:f0:26:be:0e:87:c7:be:91:42:83:5a:fc:15:5d:48:1a:21:c7:35:9a:d9:43:1d:1e:3d:5e:e3:16:6a:45:e6:e1:a0:11:2e:d7:c8:fb:98:84:58:6c:05:bf:a6:85:4a:5b:65:d0:b7:d4:68:26:7c:b9:42:f7:f4:d0:d7:c4:d8:ad:c2:89:21:59:a7:0e:b6:99:a0:2d:f2:25:aa:01:25',
	      // q = prime2
	      q: '00:e1:69:e5:a6:69:1b:fc:a0:9a:d8:d4:0d:28:53:da:1f:0a:72:66:80:47:82:5b:aa:b0:27:36:44:ac:ea:89:d5:12:6b:60:26:47:29:ea:a3:b6:2a:43:16:dc:fd:01:4c:61:97:87:1b:fa:1c:52:92:2b:e7:32:d2:bb:69:05:00:aa:37:7d:c3:7b:a7:45:45:4d:4b:6e:f3:60:18:30:f1:8e:aa:5e:be:67:b6:7b:90:b1:7b:cd:e2:62:4f:b9:6e:01:ba:ed:7f:46:26:7b:94:0f:57:80:08:cf:4b:bf:b4:ae:46:16:d9:86:00:ce:79:14:60:ae:a2:48:04:92:63',
	      // dp = exponent1
	      dp: '23:dd:fc:69:04:40:ae:d4:50:d3:27:c4:1c:b8:ce:3f:90:25:35:3f:b7:bd:28:d9:fd:cd:82:33:e7:02:46:52:aa:18:ed:de:51:d4:2d:1f:d3:4c:f4:9b:42:ad:bb:fd:99:ba:c9:0c:b0:be:30:5d:8c:ed:8f:0a:93:6f:dc:6a:54:fb:94:eb:ba:1d:8e:95:59:5d:6e:3a:11:ad:e8:9f:78:28:98:67:94:68:b6:9f:19:9e:d6:fe:44:88:62:79:a5:08:9b:09:d0:f5:78:48:42:9a:6a:c2:6a:24:c5:88:4c:e3:27:f1:81:9e:19:e3:c3:26:d1:b3:bd:4a:8e:c1',
	      // dq = exponent2
	      dq: '00:a5:eb:bd:0e:f0:ef:98:d4:df:26:1b:70:53:ee:e4:ef:54:51:41:01:cb:a1:38:b8:3b:51:a1:b0:8b:57:58:7d:6e:41:7b:54:b1:ad:38:f9:a8:6d:13:55:10:f5:6a:af:3e:66:bb:1c:ec:cd:4c:3a:2b:f6:d2:82:2b:50:f2:4d:ba:fd:7d:a5:16:af:d9:5d:59:b7:dc:c3:68:48:66:3e:68:35:1f:e8:27:8f:3b:05:16:9f:7a:bc:d8:80:b6:8d:32:d8:d5:58:89:da:69:bc:62:4e:95:ff:e6:16:6b:d6:23:31:94:40:29:53:0e:a8:31:47:b9:43:da:9f:02:e1',
	      // qi = coefficient
	      qi: '53:cf:5e:1c:16:26:cc:d2:be:2e:45:09:d5:05:5d:cc:c9:0d:fa:ac:b2:bc:12:22:a6:b9:05:a8:f2:ef:a5:06:e3:ba:f0:ff:6e:e7:6a:0c:91:a0:67:b1:1a:c6:ac:e0:09:bc:b7:e8:ac:97:a9:f7:02:a9:82:cc:14:05:05:e1:82:59:52:4d:28:d0:dc:89:db:93:10:7c:48:2e:f0:16:a8:f1:e6:5c:07:33:cb:c4:40:96:f2:07:f4:34:7c:51:30:33:aa:2b:84:6c:c0:e6:bc:a6:76:22:4b:03:e6:c9:f5:11:1c:65:19:29:76:36:e9:62:2d:af:bb:89:3d:30'
	    };
	    var private_rsa_key = Jose.Utils.importRsaPrivateKey(privateRsaKey, "RSA-OAEP");
	    var decrypter = new Jose.JoseJWE.Decrypter(cryptographer, private_rsa_key);
	    decrypter.decrypt(ciphertext).then(function (res) {
	      resolve({ result: true, data: res });
	    }).catch(function (err) {
	      resolve({ result: false, data: err });
	    });
	  });
	}
	
	exports.default = { encrypter: encrypter, decrypter: decrypter };

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(239);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(240), __esModule: true };

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(241);
	var $Object = __webpack_require__(24).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(22);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(32), 'Object', { defineProperty: __webpack_require__(28).f });


/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperty2 = __webpack_require__(238);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toast = __webpack_require__(4);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _util = __webpack_require__(94);
	
	var _mobileDetect = __webpack_require__(102);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1024);
	__webpack_require__(128);
	var util = __webpack_require__(94);
	var ajax = __webpack_require__(152);
	var docomchannel = __webpack_require__(1030);
	
	(0, _util.changeTitle)('88元红包限时领');
	var md = new _mobileDetect2.default(window.navigator.userAgent);
	var ua = detector.parse(navigator.userAgent);
	/* eslint-disable */
	var __interval;
	/* eslint-enable */
	var weixinflag = util.isWeiXin();
	var bdocpc = __webpack_require__(1031);
	// import interceptor from '../common/interceptors';
	// interceptor();
	window.onload = function () {
	  util.closeLoading();
	};
	var errorMsg = '很抱歉,网络异常,请稍后重试';
	new Vue({
	  el: '#bd',
	  components: (0, _defineProperty3.default)({}, _toast2.default.name, _toast2.default),
	  data: {
	    loading: true,
	    isShowForm: false,
	    phone: '', // 手机号
	    codeObj: {
	      code: '', // 验证码
	      isGetCode: false, //正在获取验证码
	      getCodeMsg: '获取验证码' //获取验证码提示
	    },
	    passcodeTag: '', // passcode标记
	    submitIng: false, //正在提交注册
	    regResultObj: {
	      show: false,
	      exist: false
	    },
	    downloadIng: false,
	    paramsObj: undefined,
	    btnShow: false,
	    appChannel: (0, _util.getParam)('appChannel') || 'MGMwx01'
	  },
	  ready: function ready() {
	    if (weixinflag) {
	      var url = location.href;
	      if (url.indexOf('referralCode') >= 0) {
	        url = url.replace('referralCode', 'preReferralCode');
	      }
	      var param = {
	        title: '您有30天免息券待领取，立即领取>>',
	        des: '好友已为你开通优先审批特权，最高可借50000元！',
	        url: url,
	        success: this.callback,
	        business: ("xhqb"),
	        img: ("https://c.xhqbapp.com") + '/mobile/statics/img/mgm/log.png'
	      };
	      weixin(true, param);
	      // 在微信
	    }
	
	    var paramsObj = this.paramsObj || this.getParamsObj();
	    if (paramsObj.appChannel === 'weimi16') {
	      bdocpc({
	        paramChannel: paramsObj.appChannel,
	        targetChannel: 'weimi16',
	        guid: 'tpl_udf_22294350_extra',
	        siteid: 166601,
	        pageid: 172398,
	        ucid: 24351027
	      });
	    }
	    // 用于下载的链接this.downloadChannel
	    this.downloadChannel = docomchannel.getAppChannel(paramsObj.appChannel, ['xhqb01']);
	    this.loading = false;
	  },
	  created: function created() {
	    xhTrack.log.onload('asynchronous', '记录首次访问时间', true);
	  },
	
	  methods: {
	    openForm: function openForm() {
	      xhTrack.log.onload('asynchronous', '打开注册', true);
	      this.isShowForm = true;
	    },
	    closeForm: function closeForm() {
	      this.isShowForm = false;
	    },
	    //验证手机号码
	    _verifyPhone: function _verifyPhone(phone) {
	      if (!phone) {
	        this.$refs.toast.show('请输入手机号码！');
	      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)) {
	        this.$refs.toast.show('请输入正确的手机号码！');
	      } else {
	        return true;
	      }
	      return false;
	    },
	    //验证验证码
	    _verifyCode: function _verifyCode(code) {
	      var errMsg = void 0;
	      if (!this.passcodeTag) {
	        errMsg = '请先获取验证码';
	      } else if (!code) {
	        errMsg = '请输入验证码！';
	      } else if (code.length < 6) {
	        errMsg = '请输入6位验证码！';
	      }
	      if (errMsg) {
	        this.$refs.toast.show(errMsg);
	        xhTrack.track('verify-fail', 'verify-fail', '表单验证失败', errMsg);
	        return false;
	      } else {
	        return true;
	      }
	    },
	    //60秒倒计时
	    _countdown: function _countdown() {
	      var that = this;
	      var i = 60;
	      that.codeObj.isGetCode = true;
	      that.codeObj.getCodeMsg = i + '秒后发送';
	      var __interval1 = setInterval(function () {
	        i--;
	        if (i <= 0) {
	          that._resetCountdown();
	          clearInterval(__interval1);
	        } else {
	          that.codeObj.getCodeMsg = i + '秒后发送';
	        }
	      }, 1000);
	    },
	    //重置倒计时
	    _resetCountdown: function _resetCountdown() {
	      this.codeObj.isGetCode = false;
	      this.codeObj.getCodeMsg = '获取验证码';
	    },
	    getParamsObj: function getParamsObj() {
	      //注册所需传送字段
	      var deviceID = util.storage.get('fppDeviceId') ? util.storage.get('fppDeviceId') : Guid.create().value;
	      //兼容无痕模式，防止报错  原因：兼容无痕模式操作cookie会报错
	      try {
	        util.storage.set('fppDeviceId', deviceID, { expires: 30, path: '/' });
	      } catch (e) {}
	
	      var deviceType = ua.device.family;
	      var appChannel = util.getParam('appChannel');
	      var appPostChannel = appChannel;
	      var invitationChannel = util.getParam('invitationChannel');
	      var invitationPostChannel = invitationChannel;
	
	      var deviceName = ua.device.name;
	      var clientPlatform = ua.os.family;
	      var brand = ua.device.manufacturer;
	      var osversion = ua.os.version;
	
	      //浏览器分辨率
	      var devicePixelRatio = window.devicePixelRatio;
	      var screen = window.screen;
	      var resolution = screen.width * devicePixelRatio + 'X' + screen.height * devicePixelRatio;
	      var channelName = 'WEB';
	
	      //请求验证码及注册传递参数
	      var paramsObj = {
	        deviceID: deviceID,
	        deviceType: deviceType,
	        invitationChannel: invitationPostChannel,
	        appChannel: appPostChannel,
	        deviceName: deviceName,
	        clientPlatform: clientPlatform,
	        brand: brand,
	        osversion: osversion,
	        resolution: resolution,
	        channelName: channelName
	      };
	
	      // 添加注册referral_type
	      /* eslint-disable */
	      var invitationCode = util.getParam('invitationCode');
	      /* eslint-enable */
	      // var referralCode = util.getParam('referralCode');
	      paramsObj['referralType'] = 'MGM01';
	      this.paramsObj = paramsObj;
	      return paramsObj;
	    },
	    toGetCode: function toGetCode(e) {
	      // 点击获取状态码
	      // 获取验证码
	      var that = this;
	      /* eslint-disable */
	      var phone = void 0,
	          code = void 0;
	      phone = that.phone;
	      code = that.code;
	      /* eslint-enable */
	      //重复点击验证码
	      if (that.codeObj.isGetCode) {
	        xhTrack.trackClick({
	          target: e.target,
	          label: '获取验证码(重复点击)-按钮',
	          property: 'btn-verify'
	        });
	        return;
	      }
	      var paramsObj = that.paramsObj || that.getParamsObj();
	      xhTrack.trackClick({
	        target: e.target,
	        label: '获取验证码-按钮',
	        property: 'btn-verify'
	      });
	      if (!that.codeObj._isGetCode && that._verifyPhone(phone)) {
	        __interval = that._countdown();
	        ajax.toPost({
	          vm: that,
	          url: '/auth/genToken',
	          params: $.extend({
	            phoneNum: phone,
	            bizType: 'register'
	          }, paramsObj),
	          success: function success(dataToken) {
	            var dataTokenIn = dataToken.data;
	            if (dataTokenIn.success) {
	              ajax.toPost({
	                vm: that,
	                url: '/auth/pass/sendRegisterPass',
	                params: $.extend({
	                  phoneNum: phone,
	                  bizType: 'register'
	                }, paramsObj),
	                headers: {
	                  token: dataToken.headers.token
	                },
	                success: function success(datas) {
	                  var data = datas.data;
	                  that.passcodeTag = data.passcodeTag;
	                  if (data.success) {
	                    if (data.resultMsg === '成功') {
	                      that.$refs.toast.show('验证码发送成功！');
	                      xhTrack.track('captcha-success', 'captcha-success', '获取验证码成功');
	                    } else {
	                      that.$refs.toast.show(data.resultMsg);
	                      xhTrack.track('captcha-fail', 'captcha-fail', '获取验证码失败', data.resultMsg);
	                    }
	                  } else {
	                    that.$refs.toast.show(data.resultMsg || errorMsg);
	                    that._resetCountdown();
	                  }
	                },
	                error: function error() {
	                  that.$refs.toast.show(errorMsg);
	                  that._resetCountdown();
	                  xhTrack.track('captcha-fail', 'captcha-fail-error', '获取验证码失败-网络异常', errorMsg);
	                }
	              });
	            } else {
	              that.$refs.toast.show(dataTokenIn.resultMsg || '获取验证码token失败', 2000);
	              that._resetCountdown();
	              xhTrack.track('captcha-fail', 'captcha-fail-error', '获取验证码token失败', dataTokenIn.resultMsg);
	            }
	          }
	        });
	      }
	    },
	    toRegister: function toRegister(e) {
	      // 点击注册
	      if (this.btnShow) {
	        this.$refs.toast.show('请先阅读并勾选协议');
	        return;
	      }
	      // 提交注册
	      var that = this;
	      var phone = that.phone;
	      var code = that.codeObj.code;
	      var passcodeTag = that.passcodeTag;
	      //获取邀请码
	      var invitationCode = util.getParam('invitationCode');
	      var sourceEntry = util.getParam('sourceEntry');
	      var paramsObj = that.paramsObj || that.getParamsObj();
	      //若重复提交
	      if (that.submitIng) {
	        xhTrack.trackClick({
	          target: e.target,
	          label: '立即注册(重复提交表单)-按钮',
	          property: 'btn-reg'
	        });
	        return;
	      }
	      that.submitIng = true;
	      xhTrack.trackClick({
	        target: e.target,
	        label: '立即注册(提交表单)-按钮',
	        property: 'btn-reg'
	      });
	      if (that._verifyPhone(phone) && that._verifyCode(code)) {
	        ajax.toPost({
	          vm: that,
	          url: '/auth/user/register',
	          params: $.extend({
	            phoneNum: phone,
	            smsPasscode: code,
	            passcodeTag: passcodeTag,
	            invitationCode: invitationCode,
	            sourceEntry: sourceEntry
	          }, paramsObj),
	          success: function success(datas) {
	            var data = datas.data;
	            if (data.success) {
	              that._resetCountdown();
	              //$('.result-old').addClass('hidden');
	              //$('.result-new').removeClass('hidden');
	              that.regResultObj.exist = false;
	              that.regResultObj.show = true;
	              that.hasReg = true;
	              that.submitIng = false;
	              xhTrack.track('submit-success', 'submit-success-new', '提交注册成功');
	            } else {
	              if (data.resultMsg === '用户已存在，请登录') {
	                //that.hasReg = true
	                that._resetCountdown();
	                //$('.result-new').addClass('hidden');
	                //$('.result-old').removeClass('hidden');
	                that.regResultObj.exist = true;
	                that.regResultObj.show = true;
	                that.submitIng = false;
	                xhTrack.track('submit-success', 'submit-success-already', '提交注册成功-用户已存在');
	              } else {
	                that.$refs.toast.show(data.resultMsg, 2000);
	                that.submitIng = false;
	                xhTrack.track('submit-fail', 'submit-fail', '提交注册失败', data.resultMsg);
	              }
	            }
	          },
	          error: function error(resp) {
	            that.$refs.toast.show(resp.data.errorDescription || errorMsg);
	            that.submitIng = false;
	            xhTrack.track('submit-fail', 'submit-fail-error', '提交注册失败-网络异常', errorMsg);
	          }
	        });
	      } else {
	        that.submitIng = false;
	      }
	    },
	    toDownload: function toDownload(e) {
	      var that = this;
	      var appChannel = util.getParam('appChannel');
	      //bdTrack.fpp('统计', '下载统计', appChannel);
	      xhTrack.track('xhpopulrz推广统计', '下载统计', appChannel, that.downloadChannel, weixinflag);
	      if (that.downloadIng) {
	        xhTrack.trackClick({
	          target: e.target,
	          label: '下载(重复点击)-按钮',
	          property: 'btn-download'
	        });
	        return;
	      }
	      util.showLoading();
	      that.downloadIng = true;
	
	      xhTrack.trackClick({
	        target: e.target,
	        label: '下载-按钮',
	        property: 'btn-download'
	      });
	      setTimeout(function () {
	        if (md.os() === 'iOS') {
	          location.href = 'https://itunes.apple.com/app/id1050915215';
	        } else if (weixinflag || md.match(/\sQQ/i)) {
	          location.href = ("") + '/mobile/xhpopulrz/download-app.html';
	        } else if (md.os() === 'AndroidOS') {
	          location.href = 'https://s3.cn-north-1.amazonaws.com.cn/app-download/Android/prod/' + that.downloadChannel + '.apk';
	        } else {
	          location.href = ("") + '/mobile/xhpopulrz/download-app.html?appChannel=MGMwx01';
	        }
	      }, 200);
	
	      //2秒后才允许再次点击下载
	      setTimeout(function () {
	        that.downloadIng = false;
	        util.closeLoading();
	      }, 2000);
	    },
	    blurfns: function blurfns(e) {
	      //微信IOS12以上版本微信弹出键盘底下空白
	      if (weixinflag && md.os() === 'iOS' && ua.os.version > 12) {
	        window.scroll(0, 0);
	      }
	    },
	    focusfns: function focusfns(e) {
	      //微信IOS12以上版本微信弹出键盘底下空白
	      if (weixinflag && md.os() === 'iOS' && ua.os.version > 12) {
	        window.scroll(0, 184);
	      }
	    },
	    requestFriend: function requestFriend() {
	      // 点击了参与邀请好友
	      location.href = ("https://c.xhqbapp.com") + '/mobile/mgm/index.html?appChannel=' + this.appChannel;
	    },
	    checkboxOnclick: function checkboxOnclick() {
	      this.btnShow = !this.btnShow;
	    },
	
	    //分享成功后的回调，用来插入分享记录数据
	    callback: function callback() {
	      // this.$http.post(GLOBAL_URL.ROOT + '/h5api/marketapi/mgm/getInviteCode', {
	      //   activityUrl: `${location.protocol}//${document.domain}/mobile/mgm/index.html?appChannel=${this.appChannel}`,
	      //   recommendResult: 'success',
	      // }).then(resp => {
	      //   const data = resp.json();
	      //   if (data.success) {
	      //     // 分享成功
	      //   } else {
	      //     this.loading = false;
	      //   }
	      // });
	      var self = this;
	      ajax.newPost({
	        vm: self,
	        url: ("") + '/h5api/marketapi/mgm/getInviteCode',
	        params: {
	          businessGroup: 'BGALL',
	          activityUrl: location.protocol + '//' + document.domain + '/mobile/mgm/index.html?appChannel=' + self.appChannel,
	          recommendResult: 'success'
	        },
	        success: function success(res) {
	          var data = res.data;
	          if (data.success) {
	            // 分享成功
	          } else {
	            self.loading = false;
	          }
	        },
	        error: function error(_error) {}
	      });
	    }
	  }
	});

/***/ }),

/***/ 1024:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1030:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// let md = new MobileDetect(window.navigator.userAgent);
	var ua = detector.parse(navigator.userAgent);
	var util = __webpack_require__(94);
	var docomchannel = {
	  getAppChannel: function getAppChannel(appChannel, downlist) {
	    var downList = void 0,
	        downObj = void 0,
	        downKey = void 0,
	        downArr = void 0,
	        newAppChannel = void 0;
	
	    downObj = {};
	    downKey = appChannel.replace(/\d/gi, '');
	    downList = downlist || ['xhqb01', 'shuisj00', 'jingy00', 'daikwy00', 'fengs00', 'jielm00', '51xyk00', 'rongzj00', 'sudzj00'];
	
	    downList.forEach(function (item) {
	      var key = item.replace(/\d/gi, '');
	      downObj[key] = downObj[key] || [];
	      downObj[key].push(item);
	    });
	
	    downArr = downObj[downKey] || [];
	
	    if (downArr.indexOf(appChannel) > -1) {
	      newAppChannel = appChannel;
	    } else {
	      if (downArr.indexOf(downKey + '00') > -1) {
	        newAppChannel = downKey + '00';
	      } else {
	        newAppChannel = 'xhqb01';
	      }
	    }
	
	    return newAppChannel;
	  },
	  getParamsObj: function getParamsObj() {
	    //注册所需传送字段
	    var deviceID = util.storage.get('fppDeviceId') ? util.storage.get('fppDeviceId') : Guid.create().value;
	    //兼容无痕模式，防止报错  原因：兼容无痕模式操作cookie会报错
	    try {
	      util.storage.set('fppDeviceId', deviceID, { expires: 30, path: '/' });
	    } catch (e) {}
	
	    var deviceType = ua.device.family;
	    var appChannel = util.getParam('appChannel');
	    var appPostChannel = appChannel;
	    var deviceName = ua.device.name;
	    var clientPlatform = ua.os.family;
	    var brand = ua.device.manufacturer;
	    var osversion = ua.os.version;
	
	    //浏览器分辨率
	    var devicePixelRatio = window.devicePixelRatio;
	    var screen = window.screen;
	    var resolution = screen.width * devicePixelRatio + 'X' + screen.height * devicePixelRatio;
	    var channelName = 'WEB';
	
	    //请求验证码及注册传递参数
	    var paramsObj = {
	      deviceID: deviceID,
	      deviceType: deviceType,
	      appChannel: appPostChannel,
	      deviceName: deviceName,
	      clientPlatform: clientPlatform,
	      brand: brand,
	      osversion: osversion,
	      resolution: resolution,
	      channelName: channelName
	    };
	
	    // 添加注册referral_type
	    // let referralCode = util.getParam('referralCode');
	    paramsObj['referralType'] = 'MGM01';
	    this.paramsObj = paramsObj;
	    return paramsObj;
	  }
	};
	module.exports = docomchannel;

/***/ }),

/***/ 1031:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (obj) {
	  /*
	    * paramChannel
	    * targetChannel:zhw_weimi65
	    * guid
	    * siteid
	    * pageid
	    * ucid
	    * */
	  if (obj.paramChannel === obj.targetChannel) {
	    console.log('begin ocpc...');
	    $('#btnReg').attr('data-click', '{"type":"book"}');
	    window.statConf = { 'guid': obj.guid, 'siteid': obj.siteid, 'pageid': obj.pageid, 'ucid': obj.ucid };
	    var ta = document.createElement('script');
	    ta.type = 'text/javascript';
	    ta.async = true;
	    ta.src = document.location.protocol + '//' + 'isite.baidu.com/static/stat.js';
	    var s = document.getElementsByTagName('script')[0];
	    s.parentNode.insertBefore(ta, s);
	  }
	};

/***/ })

});


// WEBPACK FOOTER //
// statics/js/mgm/asynchronous-827548a7.js